import 'openlayers/css/ol.css';
import 'ol3-photon/src/ol3.photon.css';
import './../distribution/d3RangeSlider/d3RangeSlider.css';
import './../assets/main.css';

import ol from 'openlayers';
import proj4 from 'proj4';
ol.proj.setProj4(proj4);
import csv2geojson from 'csv2geojson';
import micromustache from './../distribution/micromustache';
import Photon from 'ol3-photon';
import createD3RangeSlider from './../distribution/d3RangeSlider/d3RangeSlider';
// Photon = Photon.Photon;
import * as d3 from 'd3';
import { TextBox } from 'd3plus-text';
import { linearRegression, linearRegressionLine } from 'simple-statistics';
import { saveAs } from 'file-saver/FileSaver';

var resolutions = [];
var matrixIds = [];
const proj3857 = ol.proj.get('EPSG:3857');
var maxResolution = ol.extent.getWidth(proj3857.getExtent()) / 256;

proj4.defs('EPSG:2154','+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
const bboxProj2154AsWGS = [51.56, -9.86, 41.15, 10.38];
const proj2154 = ol.proj.get('EPSG:2154');

var fromLonLatTransform = ol.proj.getTransform('EPSG:4326', proj2154);
// very approximate calculation of projection extent
// var extentProj2154 = ol.extent.applyTransform([
//   bboxProj2154AsWGS[1],
//   bboxProj2154AsWGS[2],
//   bboxProj2154AsWGS[3],
//   bboxProj2154AsWGS[0]
// ], fromLonLatTransform);

// proj2154.setExtent(extentProj2154);
var extentZoom = ol.proj.transformExtent([
  -1.954971843164693,
  46.9190887269987,
  5.623188812268172,
  50.08899006978729
], 'EPSG:4326', 'EPSG:3857');

var firstGroup = [
  'checked_richesse_specifique',
  'checked_etat_ipr',
  'checked_stations_echantillonnage'
];
var rivieresGroup = [
  'checked_qualite_eau_etat_pc',
  'checked_qualite_eau_etat_ps',
  'checked_qualite_eau_bio',
  'checked_diversite_habitat',
  'checked_presence_ripisylve',
  'checked_erosion_sol',
  'checked_taux_etag',
  'checked_taux_frac',
  'checked_assemblage_pisci_ref'
]


function upper(lower) {
  return lower.replace(/^\w/, c => c.toUpperCase());
}

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

function zip(arrays) {
  return arrays[0].map(function(_,i){
    return arrays.map(function(array){return array[i];});
  });
}

function getLegendGraphicOptions(layerName) {
  return {
    SERVICE: 'WMS',
    VERSION: '1.1.1',
    REQUEST: 'GetLegendGraphic',
    FORMAT: 'image/png',
    TRANSPARENT: true,
    STYLES: '',
    WIDTH: 20,
    HEIGHT: 20,
    LAYER: layerName || 'general:obst_ecoul_bsn',
    LEGEND_OPTIONS: 'forceLabels:on;fontName:Times New Roman;fontAntiAliasing:true;fontColor:#000033;fontSize:11;bgColor:#FFFFEE;dpi:90;'
  }
};

function transformData(json, field, colors, libelles) {
  let sum = json.list.reduce((acc, curr) => {
    acc += curr.tot;
    return acc;
  }, 0);
  let data = json.list.map((stat, idx) => {
    let percentage = sum !== 0 ? ((stat.tot / sum) * 100) : 0;
    return {
      name: stat[field],
      count: stat.tot,
      percentage: Number.isInteger(percentage) ? percentage : percentage.toFixed(2),
      color: colors[libelles.indexOf(stat[field])]
    };
  });
  return data;
}

class PieChart {
  constructor(selector, height, width, radius, colors, libelles) {
    this.selector = selector;
    this.height = height;
    this.width = width;
    this.radius = radius;
    this.data = [];

    this.colors = colors;
    this.libelles = libelles;

    var svg = d3.select(selector).append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    this.svg = svg;
  }

  piechart(data, fieldlibelle) {

    var arc = d3.arc()
      .outerRadius(this.radius - 10)
      .innerRadius(0);

    var pie = d3.pie()
      .sort(null)
      .value(function(d) {
        return d.count;
      });

    var content = this.svg.selectAll(".arc")
      .data(pie(data));

    var g = content.enter().append("g")
      .merge(content);

    this.svg.selectAll('path').remove();
    this.svg.selectAll('text').remove();

    var arcs = g.append("path")
      .merge(g)
      .attr("d", arc)
      .style("fill", function(d,i) {
        return d.data.color;
      });


      if (fieldlibelle === 'name') {
        var div = d3.select("body").append("div")
          .attr("class", "tooltip")
          .style("opacity", 0);

        arcs.on("mouseover", function(d) {
          div.transition()
             .duration(200)
             .style("opacity", .9);
          div.html((d.data[fieldlibelle] !== 'Autres' ? upper(especes_by_key[d.data[fieldlibelle]]) : 'Autres') +
                    "<br/>"  + d.data.percentage + '%')
             .style("left", (d3.event.pageX) + "px")
             .style("top", (d3.event.pageY - 28) + "px");
        })
        .on("mouseout", function(d) {
          div.transition()
             .duration(500)
             .style("opacity", 0);
        });
      }

    g.append("text")
      .attr("dy", ".50em")
      .style("text-anchor", "middle")
      .style("font", "14px Quicksand")
      // .merge(g)
      .attr("transform", function(d) {
        let _d = arc.centroid(d);
        _d[0] *= 2.4; // multiply by a constant factor
        _d[1] *= 2.4; // multiply by a constant factor
        return "translate(" + _d + ")";
      })
      .text(function(d) {
        return d.data[fieldlibelle];
      });

  }

  async fetchPieChart(url, field, transform) {
    var json = await fetch(url).then(response => {
      return response.json();
    });
    var patch_libelles = {
      'zones_humides': 'Restauration de zones humides',
      'continuite': 'Restauration de la continuit\u00e9 \u00e9cologique',
      'hydromorphologie': 'Restauration hydromorphologique'
    }
    if ('list' in json) {
      json.list.forEach(el => {
        if (Object.keys(patch_libelles).includes(el.type_op)) {
          el.type_op = patch_libelles[el.type_op]
        }
      })
    }

    var data = transform(json, field, this.colors, this.libelles);
    if (json.species) {
      if (data.length > 0) {
        this.piechart(data, 'name');
      }
      this.data = data;
    } else {
      this.piechart(data, 'count');
    }
    return data;
  }
}

class BarChart {
  constructor(selector, height, width, margin, colors, libelles, colorbar = '#5a9ad7') {
    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;
    this.x = d3.scaleBand().rangeRound([0, width]).padding(0.1);
    this.xAxis = d3.axisBottom(this.x);

    var svg = d3.select(selector).append("svg")
        .attr("width", width + this.margin.left + this.margin.right)
        .attr("height", height + this.margin.top + this.margin.bottom)
      .append("g")
        .attr("transform", `translate(${this.margin.left}, ${this.margin.top})`);

    this.colors = colors;
    this.libelles = libelles;
    this.svg = svg;
    this.colorbar = colorbar;
  }

  updateBarChart(data, field) {
    var max = Math.max(...data.map(el => el.count));
    // Change libelle to add count to the name
    data.forEach(el => {
      el.name = el.name.replace('hydromorphologique', 'hydromorpho.') + ' (' + String(el.count) + ')';
    });
    this.x.domain(data.map(d => d.name));
    this.svg.selectAll("rect").remove();
    var content = this.svg.selectAll("rect")
      .data(data);

    content
      .enter()
      .append("rect")
      .attr("width", (d, i) => {
        //console.log('bandwith', this.x.bandwidth());
        return this.x.bandwidth();
        // return (i + 1) * this.width / data.length;
        // return (this.width - (data.length - 1) * 5) / data.length;
      })
      .attr("fill", (d) => {
        return d.color;
      })
    .merge(content)
      .attr("x", (d, i) => {
        return this.x(d.name);
      })
      .attr("y", (d) => {
        if (d.count == 0) {
          return this.height;
        } else {
          return this.height - d.count * (this.height / max);
        }
      })
      .attr("height", (d) => {
        if (d.count == 0) {
          return 1;
        } else {
          return d.count * (this.height / max);  // <-- Times four!
        }
      });

    content.exit().remove();

    // debugger;
    this.svg.selectAll('.x.axis').remove();

    this.svg.append("g")
          .attr("class", "x axis")
          .attr("transform", `translate(0, ${this.height})`)
          .call(this.xAxis)
        .selectAll(".tick text")
        .call(wrap, this.x.bandwidth());

    function wrap(text, width) {
      text.each(function() {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            y = text.attr("y"),
            dy = parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node().getComputedTextLength() > width) {
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", `${++lineNumber * lineHeight + dy}em`).text(word);
          }
        }
      });
    }
  }

  fetchBarChart(url, field) {
    fetch(url)
    .then(response => response.json())
    .then(json => {
      var patch_libelles = {
        'zones_humides': 'Restauration de zones humides',
        'continuite': 'Restauration de la continuit\u00e9 \u00e9cologique',
        'hydromorphologie': 'Restauration hydromorphologique'
      }
      if ('list' in json) {
        json.list.forEach(el => {
          if (Object.keys(patch_libelles).includes(el.type_op)) {
            el.type_op = patch_libelles[el.type_op]
          }
        })
      }
      let sum = json.list.reduce((acc, curr) => {
        acc += curr.tot;
        return acc;
      }, 0);
      let data = json.list.map((stat, idx) => {
        let percentage = sum !== 0 ? ((stat.tot / sum) * 100) : 0;
        return {
          name: stat[field],
          count: stat.tot,
          percentage: Number.isInteger(percentage) ? percentage : percentage.toFixed(2),
          color: this.colors[this.libelles.indexOf(stat[field])]
        };
      });
      this.updateBarChart(data, field);
    });
  }
}

class BarChartIPR {
  constructor(selector, height, width, margin) {
    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;

    var svg = d3.select(selector).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

    var x = d3.scaleBand().rangeRound([0, width]).padding(0.1),
        y = d3.scaleLinear().rangeRound([height, 0]);

    var colorsQuali = {
      "Excellent": '#25408f',
      "Bonne": '#41ad49',
      "Médiocre": '#fff200',
      "Mauvaise": '#f8971d',
      "Très mauvaise": '#d2232a',
      "Absence de données": '#6792fd'
    };

    this.colorsQuali = colorsQuali;
    this.svg = svg;
    this.x = x;
    this.y = y;
  }

  updateBarChart(data, maxY) {
    this.x.domain(data.map(function(d) {
      return d.classe_quali;
    }));
    // this.y.domain([0, d3.max(data, function(d) {
    //   return d.tot;
    // })]);
    this.y.domain([0, maxY]);
    this.svg.selectAll('g').remove();
    var textX = this.svg.append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + this.height + ")")
        .call(d3.axisBottom(this.x))
          .selectAll("text");

          textX.merge(textX).style("text-anchor", "end")
          .attr("dx", "-.8em")
          .attr("dy", ".15em")
          .attr("transform", "rotate(-65)");

    var textY = this.svg.append("g")
        .attr("class", "axis axis--y")
        .call(d3.axisLeft(this.y).ticks(5, "s"));
      textY.append("text").merge(textY)
        .attr("y", 6)
        .attr("dy", "1.71em")
        .attr("text-anchor", "end")
        .text("Frequency");

    this.svg.selectAll("rect").remove();
    this.svg.selectAll(".bar")
      .data(data).enter().append("rect")
        .attr("x", d => {
          return this.x(d.classe_quali);
        })
        .attr("y", d => {
          return this.y(d.tot);
        })
        .attr("fill", d =>  {
          return this.colorsQuali[d.classe_quali];
        })
        .attr("width", this.x.bandwidth())
        .attr("height", d => {
          // console.log(this.height - this.y(d.tot));
          return (this.height - this.y(d.tot)) == 0 ? this.height - this.y(0.1) : (this.height - this.y(d.tot));
        });
  }

  fetchBarChart(url, maxY) {
    fetch(url)
    .then(response => response.json())
    .then(json => {
      let data = json.list.filter(el => el.classe_quali !== "Absence de données");
      this.updateBarChart(data, maxY);
    });
  }
}

class BarChartEvolutionSpecies {
  constructor(selector, height, width, margin, colors, libelles, colorbar = '#5a9ad7') {
    this.selector = selector;
    this.height = height;
    this.width = width;
    this.margin = margin;
    this.data = [];
    var x = d3.scaleTime()
        .range([0, width]);

    var y = d3.scaleLinear()
        .range([height, 0]);

    var xAxis = d3.axisBottom(x)
      .ticks(d3.timeYear.every(1));
    var yAxis = d3.axisLeft(y);
    xAxis.tickFormat(d3.timeFormat("%y"));

    var svg = d3.select(selector).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.x = x;
    this.y = y;
    this.xAxis = xAxis;
    this.yAxis = yAxis;
    this.height = height;
    this.svg = svg;
  }

  updateBarChart(data, field) {
    // console.log('BarChartEvolutionSpecies data', data);
    this.x.domain(d3.extent(data, function(d) { return d.date_ech; }));
    this.y.domain(d3.extent(data, function(d) { return d.value; }));

    var line = d3.line()
        .x(d => { return this.x(d.date_ech); })
        .y(d => { return this.y(d.value); });

    // Derive a linear regression
    var regression = linearRegression(data.map(function(d) {
      return [+d.date_ech, d.value];
    }));

    var lin = linearRegressionLine(regression);

    // Create a line based on the beginning and endpoints of the range
    var lindata = this.x.domain().map(function(x) {
      return {
        date_ech: new Date(x),
        value: lin(+x)
      };
    });

    this.svg.selectAll("*").remove();

    this.svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + this.height + ")")
        .call(this.xAxis);

    this.svg.append("g")
        .attr("class", "y axis")
        .call(this.yAxis)
      .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end");

    this.svg.append("path")
        .datum(data)
        .attr("class", "line")
        .attr("d", line);

    this.svg.selectAll(".dot")
          .data(data)
        .enter().append("circle")
          .attr("class", "dot")
          .attr("opacity", 0.9)
          .attr("r", 2)
          .attr("cx", d => { return this.x(d.date_ech); })
          .attr("cy", d => { return this.y(d.value); })
          .style("fill", "red").
          style("stroke"," lightgrey" ).style("stroke-width","1px");

    this.svg.append("path")
        .datum(lindata)
        .attr("class", "reg")
        .attr("d", line);

    // text label for the x axis
    this.svg.append("text")
        .attr("transform",
              "translate(" + (this.width / 2) + " ," +
                             (this.height + this.margin.top + 20) + ")")
        .style("text-anchor", "middle")
        .style("font", "14px Quicksand")
        .text("Année");

    // text label for the y axis
    this.svg.append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 0 - this.margin.left - 5)
        .attr("x",0 - (this.height / 2))
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .style("font", "14px Quicksand")
        .text("Densité");

  }

  fetchBarChart(url, field) {
    var that = this;
    fetch(url)
    .then(response => response.json())
    .then(json => {
      var parseDate = d3.timeParse("%Y-%m-%d");
      if (Object.keys(json.species).length > 0) {
        var data = json.species[field].map((el, index) => {
          return {
            date_ech: parseDate(json.species['date_ech'][index]),
            value: el
          };
        });
        // console.log(data);
        this.updateBarChart(data, field);
        that.data = data;
      } else {
        that.data = [];
        console.log('Pas de données');
      }
    });
  }
}

/*  Copyright (c) 2016 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/** A simple push button control
* @constructor
* @extends {ol.control.Control}
* @param {Object=} options Control options.
* @param {String} options.className class of the control
* @param {String} options.title title of the control
* @param {String} options.html html to insert in the control
* @param {function} options.handleClick callback when control is clicked (or use change:active event)
*/
ol.control.Button = function(options) {
  options = options || {};
  var element = document.createElement('div');
  element.className = (options.className || '') + ' ol-button ol-unselectable ol-control';

  var self = this;
  var bt = document.createElement('button');
  bt.type = 'button';
  bt.title = options.title;
  bt.innerHTML = options.html || "";
  bt.addEventListener("click", function(e) {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (options.handleClick) {
      options.handleClick.call(self, e);
    }
  });
  element.appendChild(bt);

  if (!options.title) {
    bt.title = bt.firstElementChild.title;
  }
  ol.control.Control.call(this, {
    element: element,
    target: options.target
  });
  if (options.title) {
    this.set("title", options.title);
  }
};

ol.inherits(ol.control.Button, ol.control.Control);


function getHeight(el) {
  const styles = window.getComputedStyle(el);
  const height = el.offsetHeight;
  const borderTopWidth = parseFloat(styles.borderTopWidth);
  const borderBottomWidth = parseFloat(styles.borderBottomWidth);
  const paddingTop = parseFloat(styles.paddingTop);
  const paddingBottom = parseFloat(styles.paddingBottom);
  return height - borderBottomWidth - borderTopWidth - paddingTop - paddingBottom;
}

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * @classdesc
 *    OpenLayers 3 Scale Line Control integrated in the canvas (for jpeg/png
 * @see http://www.kreidefossilien.de/webgis/dokumentation/beispiele/export-map-to-png-with-scale
 *
 * @constructor
 * @extends {ol.control.ScaleLine}
 * @param {Object=} options extend the ol.control.ScaleLine options.
 *  @param {ol.style.Style} options.style used to draw the scale line (default is black/white, 10px Arial).
 */

ol.control.CanvasScaleLine = function(options)
{ ol.control.ScaleLine.call(this, options);
  this.scaleHeight_ = 6;
  // Get style options
  if (!options) options={};
  if (!options.style) options.style = new ol.style.Style();
  this.setStyle(options.style);
};
ol.inherits(ol.control.CanvasScaleLine, ol.control.ScaleLine);
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {_ol_Map_} map Map.
 * @api stable
 */
ol.control.CanvasScaleLine.prototype.setMap = function (map)
{ var oldmap = this.getMap();
  if (this._listener) {
    ol.Observable.unByKey(this._listener);
  }
  this._listener = null;
  ol.control.ScaleLine.prototype.setMap.call(this, map);
  if (oldmap) {
    oldmap.renderSync();
  }
  // Add postcompose on the map
  if (map) {
    this._listener = map.on('postcompose', this.drawScale_.bind(this));
  }
  // Hide the default DOM element
  this.element.style.visibility = 'hidden';
  this.olscale = this.element.querySelector(".ol-scale-line-inner");
};
/**
 * Change the control style
 * @param {_ol_style_Style_} style
 */
ol.control.CanvasScaleLine.prototype.setStyle = function (style)
{ var stroke = style.getStroke();
  this.strokeStyle_ = stroke ? ol.color.asString(stroke.getColor()) : "#000";
  this.strokeWidth_ = stroke ? stroke.getWidth() : 2;
  var fill = style.getFill();
  this.fillStyle_ = fill ? ol.color.asString(fill.getColor()) : "#fff";
  var text = style.getText();
  this.font_ = text ? text.getFont() : "10px Arial";
  stroke = text ? text.getStroke() : null;
  fill = text ? text.getFill() : null;
  this.fontStrokeStyle_ = stroke ? ol.color.asString(stroke.getColor()) : this.fillStyle_;
  this.fontStrokeWidth_ = stroke ? stroke.getWidth() : 3;
  this.fontFillStyle_ = fill ? ol.color.asString(fill.getColor()) : this.strokeStyle_;
  // refresh
  if (this.getMap()) this.getMap().render();
};
/*
  * Draw attribution in the final canvas
  * @private
  */
ol.control.CanvasScaleLine.prototype.drawScale_ = function(e)
{ if (this.element.style.visibility !== "hidden") return;
  var ctx = e.context;
  // Get size of the scale div
  var scalewidth = parseInt(this.olscale.style.width);
  if (!scalewidth) return;
  var text = this.olscale.textContent;
  var position = {left: this.element.offsetLeft, top: this.element.offsetTop};
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio,ratio);
  // Position if transform:scale()
  var container = this.getMap().getTargetElement();
  var scx = container.offsetWidth / container.getBoundingClientRect().width;
  var scy = container.offsetHeight / container.getBoundingClientRect().height;
  position.left *= scx;
  position.top *= scy;
  // On top
  position.top += getHeight(this.element) - this.scaleHeight_;
  // Draw scale text
  ctx.beginPath();
    ctx.strokeStyle = this.fontStrokeStyle_;
    ctx.fillStyle = this.fontFillStyle_;
    ctx.lineWidth = this.fontStrokeWidth_;
    ctx.textAlign = "center";
  ctx.textBaseline ="bottom";
    ctx.font = this.font_;
  ctx.strokeText(text, position.left + scalewidth / 2, position.top);
    ctx.fillText(text, position.left + scalewidth / 2, position.top);
  ctx.closePath();
  // Draw scale bar
  position.top += 2;
  ctx.lineWidth = this.strokeWidth_;
  ctx.strokeStyle = this.strokeStyle_;
  var max = 4;
  var n = parseInt(text);
  while (n%10 === 0) n/=10;
  if (n%5 === 0) max = 5;
  for (var i=0; i<max; i++)
  { ctx.beginPath();
    ctx.fillStyle = i%2 ? this.fillStyle_ : this.strokeStyle_;
    ctx.rect(position.left + i * scalewidth / max, position.top, scalewidth / max, this.scaleHeight_);
    ctx.stroke();
    ctx.fill();
    ctx.closePath();
  }
  ctx.restore();
};

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * OpenLayers 3 Title Control integrated in the canvas (for jpeg/png
 *
 * @constructor
 * @extends {ol.control.Control}
 * @param {Object=} options extend the ol.control options.
 *  @param {ol.style.Style} options.style style usesd to draw the title.
 */
ol.control.CanvasTitle = function(options)
{ if (!options) options={};
  // Get style options
  if (!options.style) options.style = new ol.style.Style();
  this.setStyle(options.style);
  // Initialize parent
  var elt = document.createElement('div');
  elt.textContent = this.text_;
  elt.className = 'ol-title ol-unselectable';
  var css = {
    font: this.font_,
    position: 'absolute',
    top:0,
    left:0,
    right:0,
    display: 'block',
    visibility: 'hidden'
  };
  Object.keys(css).forEach(function(key) {
    elt.style[key] = css[key];
  });
  ol.control.Control.call(this,
  { element: elt,
    target: options.target
  });
};
ol.inherits(ol.control.CanvasTitle, ol.control.Control);
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {_ol_Map_} map Map.
 * @api stable
 */
ol.control.CanvasTitle.prototype.setMap = function (map)
{ var oldmap = this.getMap();
  if (this._listener) ol.Observable.unByKey(this._listener);
  this._listener = null;
  ol.control.Control.prototype.setMap.call(this, map);
  if (oldmap) oldmap.renderSync();
  // Get change (new layer added or removed)
  if (map) {
    this._listener = map.on('postcompose', this.drawTitle_.bind(this));
  }
};
/**
 * Change the control style
 * @param {ol.style.Style} style
 */
ol.control.CanvasTitle.prototype.setStyle = function (style)
{ var text = style.getText();
  this.font_ = text ? text.getFont() || "20px Arial" : "20px Arial";
  this.text_ = text ? text.getText() : "";
  var stroke = text ? text.getStroke() : null;
  var fill = text ? text.getFill() : null;
  this.strokeStyle_ = stroke ? ol.color.asString(stroke.getColor()) : "#fff";
  this.fillStyle_ = fill ? ol.color.asString(fill.getColor()) : "#000";
  if (this.element)
  { this.element.textContent = this.text_;
    this.element.style.font = this.font_;
  }
  // refresh
  if (this.getMap()) this.getMap().render();
};
/**
 * Set the map title
 * @param {string} map title.
 * @api stable
 */
ol.control.CanvasTitle.prototype.setTitle = function (title)
{ this.text_ = title;
  this.element.textContent = this.text_;
  if (this.getMap()) this.getMap().renderSync();
};
/**
 * Get the map title
 * @param {string} map title.
 * @api stable
 */
ol.control.CanvasTitle.prototype.getTitle = function (title)
{ return this.text_;
};
/**
 * Set control visibility
 * @param {bool} b
 * @api stable
 */
ol.control.CanvasTitle.prototype.setVisible = function (b)
{ if (b) el.style.display = '';
  else el.style.display = 'none';
  if (this.getMap()) this.getMap().renderSync();
};
/**
 * Get control visibility
 * @return {bool}
 * @api stable
 */
ol.control.CanvasTitle.prototype.getVisible = function (b)
{ return this.element.style.display !== 'none';
};
/** Draw scale line in the final canvas
*/
ol.control.CanvasTitle.prototype.drawTitle_ = function(e)
{ if (!this.getVisible()) return;
  var ctx = e.context;
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio,ratio);
  var w = ctx.canvas.width/ratio;
  var h = getHeight(this.element);
  var position = { top:0, left:w/2 };
  ctx.beginPath();
    ctx.fillStyle = this.strokeStyle_;
  ctx.rect(0,0, w, h);
  ctx.fill();
  ctx.closePath();
  ctx.beginPath();
    ctx.fillStyle = this.fillStyle_;
    ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = this.font_;
    ctx.fillText(this.text_, position.left, position.top +h/2);
  ctx.closePath();
  ctx.restore();
};

/*  Copyright (c) 2015 Jean-Marc VIGLINO,
  released under the CeCILL-B license (French BSD license)
  (http://www.cecill.info/licences/Licence_CeCILL-B_V1-en.txt).
*/
/**
 * @classdesc
 *   OpenLayers 3 Attribution Control integrated in the canvas (for jpeg/png
 * @see http://www.kreidefossilien.de/webgis/dokumentation/beispiele/export-map-to-png-with-scale
 *
 * @constructor
 * @extends {ol.control.Attribution}
 * @param {Object=} options extend the ol.control.Attribution options.
 *  @param {ol.style.Style} options.style  option is usesd to draw the text.
 */
ol.control.CanvasAttribution = function(options)
{ if (!options) options = {};
  ol.control.Attribution.call(this, options);
  // Draw in canvas
  this.isCanvas_ = !!options.canvas;
  // Get style options
  if (!options) options={};
  if (!options.style) options.style = new ol.style.Style();
  this.setStyle (options.style);
};
ol.inherits(ol.control.CanvasAttribution, ol.control.Attribution);
/**
 * Draw attribution on canvas
 * @param {boolean} b draw the attribution on canvas.
 */
ol.control.CanvasAttribution.prototype.setCanvas = function (b)
{ this.isCanvas_ = b;
  this.element.style.visibility = b ? "hidden":"visible";
  if (this.map_) this.map_.renderSync();
};
/**
 * Change the control style
 * @param {ol.style.Style} style
 */
ol.control.CanvasAttribution.prototype.setStyle = function (style)
{ var text = style.getText();
  this.font_ = text ? text.getFont() : "10px Arial";
  var stroke = text ? text.getStroke() : null;
  var fill = text ? text.getFill() : null;
  this.fontStrokeStyle_ = stroke ? ol.color.asString(stroke.getColor()) : "#fff";
  this.fontFillStyle_ = fill ? ol.color.asString(fill.getColor()) : "#000";
  this.fontStrokeWidth_ = stroke ? stroke.getWidth() : 3;
  if (this.getMap()) this.getMap().render();
};
/**
 * Remove the control from its current map and attach it to the new map.
 * Subclasses may set up event handlers to get notified about changes to
 * the map here.
 * @param {ol.Map} map Map.
 * @api stable
 */
ol.control.CanvasAttribution.prototype.setMap = function (map)
{ var oldmap = this.getMap();
  if (this._listener) ol.Observable.unByKey(this._listener);
  this._listener = null;
  ol.control.ScaleLine.prototype.setMap.call(this, map);
  if (oldmap) oldmap.renderSync();
  // Get change (new layer added or removed)
  if (map) {
    this._listener = map.on('postcompose', this.drawAttribution_.bind(this));
  }
  this.map_ = map;
  this.setCanvas (this.isCanvas_);
};
/**
 * Draw attribution in the final canvas
 * @private
 */
ol.control.CanvasAttribution.prototype.drawAttribution_ = function(e)
{ var ctx = e.context;
  if (!this.isCanvas_) return;
  var text = "";
  Array.from(this.element.querySelectorAll('li'))
    .filter(function(el) {
      return el.style.display !== "none";
    })
    .map(function(el) {
      text += (text ? " - ":"") + el.textContent;
    });
  // Get size of the scale div
  var position = {left: this.element.offsetLeft, top: this.element.offsetTop};
  // Retina device
  var ratio = e.frameState.pixelRatio;
  ctx.save();
  ctx.scale(ratio,ratio);
  // Position if transform:scale()
  var container = this.getMap().getTargetElement();
  var scx = container.offsetWidth / container.getBoundingClientRect().width;
  var scy = container.offsetHeight / container.getBoundingClientRect().height;
  position.left *= scx;
  position.top *= scy;
  position.right = position.left + this.element.offsetWidth;
  position.bottom = position.top + this.element.offsetHeight;
  // Draw scale text
  ctx.beginPath();
    ctx.strokeStyle = this.fontStrokeStyle_;
    ctx.fillStyle = this.fontFillStyle_;
    ctx.lineWidth = this.fontStrokeWidth_;
    ctx.textAlign = "right";
  ctx.textBaseline ="bottom";
    ctx.font = this.font_;
  ctx.strokeText(text, position.right, position.bottom);
    ctx.fillText(text, position.right, position.bottom);
  ctx.closePath();
  ctx.restore();
};

for (var i = 0; i < 20; i++) {
  matrixIds[i] = i.toString();
  resolutions[i] = maxResolution / Math.pow(2, i);
}

// var key = '3mdalal1m4zhug5t1gytqnly'; // Own key
const key = 'ocfbpru9z3lkhexj2ovquub8';

var especes = [
  {
    "code": "ABH",
    "genre": "M",
    "article": "L'",
    "nom_commun": "able de Heckel",
    "type_espece": "eih"
  },
  {
    "code": "ABL",
    "genre": "F",
    "article": "L'",
    "nom_commun": "ablette",
    "type_espece": "enp"
  },
  {
    "code": "CTI",
    "genre": "M",
    "article": "L'",
    "nom_commun": "amour blanc",
    "type_espece": "eih"
  },
  {
    "code": "ASP",
    "genre": "M",
    "article": "L'",
    "nom_commun": "aspe",
    "type_espece": "eih"
  },
  {
    "code": "BAF",
    "genre": "M",
    "article": "Le",
    "nom_commun": "barbeau fluviatile",
    "type_espece": "enp"
  },
  {
    "code": "BBG",
    "genre": "M",
    "article": "Le",
    "nom_commun": "black bass à grande bouche",
    "type_espece": "eih"
  },
  {
    "code": "BLN",
    "genre": "M",
    "article": "Le",
    "nom_commun": "blageon",
    "type_espece": "eih"
  },
  {
    "code": "BOU",
    "genre": "F",
    "article": "La",
    "nom_commun": "bouvière",
    "type_espece": "enp"
  },
  {
    "code": "BRB",
    "genre": "F",
    "article": "La",
    "nom_commun": "brème bordelière",
    "type_espece": "enp"
  },
  {
    "code": "BRE",
    "genre": "F",
    "article": "La",
    "nom_commun": "brème commune",
    "type_espece": "enp"
  },
  {
    "code": "BRO",
    "genre": "M",
    "article": "Le",
    "nom_commun": "brochet",
    "type_espece": "enp"
  },
  {
    "code": "CAG",
    "genre": "M",
    "article": "Le",
    "nom_commun": "carassin argenté",
    "type_espece": "eih"
  },
  {
    "code": "CAS",
    "genre": "M",
    "article": "Le",
    "nom_commun": "carassin commun",
    "type_espece": "eih"
  },
  {
    "code": "CAD",
    "genre": "M",
    "article": "Le",
    "nom_commun": "carassin doré",
    "type_espece": "eih"
  },
  {
    "code": "CAR",
    "genre": "F",
    "article": "La",
    "nom_commun": "carpe argentée",
    "type_espece": "eih"
  },
  {
    "code": "CCO",
    "genre": "F",
    "article": "La",
    "nom_commun": "carpe commune",
    "type_espece": "eih"
  },
  // {
  //   "code": "CCU",
  //   "genre": "F",
  //   "article": "La",
  //   "nom_commun": "carpe cuir",
  //   "type_espece": "eih"
  // },
  // {
  //   "code": "CMI",
  //   "genre": "F",
  //   "article": "La",
  //   "nom_commun": "carpe miroir",
  //   "type_espece": "eih"
  // },
  {
    "code": "CHA",
    "genre": "M",
    "article": "Le",
    "nom_commun": "chabot",
    "type_espece": "enp"
  },
  {
    "code": "CHE",
    "genre": "M",
    "article": "Le",
    "nom_commun": "chevesne",
    "type_espece": "enp"
  },
  {
    "code": "EPI",
    "genre": "M",
    "article": "L'",
    "nom_commun": "épinoche",
    "type_espece": "enp"
  },
  {
    "code": "EPT",
    "genre": "M",
    "article": "L'",
    "nom_commun": "épinochette",
    "type_espece": "enp"
  },
  {
    "code": "GAR",
    "genre": "M",
    "article": "Le",
    "nom_commun": "gardon",
    "type_espece": "enp"
  },
  {
    "code": "GOB",
    "genre": "M",
    "article": "Le",
    "nom_commun": "gobie des sables",
    "type_espece": "enp"
  },
  {
    "code": "GOU",
    "genre": "M",
    "article": "Le",
    "nom_commun": "goujon",
    "type_espece": "enp"
  },
  {
    "code": "GRE",
    "genre": "F",
    "article": "La",
    "nom_commun": "gremille",
    "type_espece": "eih"
  },
  {
    "code": "HOT",
    "genre": "M",
    "article": "Le",
    "nom_commun": "hotu",
    "type_espece": "eih"
  },
  {
    "code": "IDE",
    "genre": "M",
    "article": "L'",
    "nom_commun": "ide mélanote",
    "type_espece": "eih"
  },
  {
    "code": "LPP",
    "genre": "F",
    "article": "La",
    "nom_commun": "lamproie de planer",
    "type_espece": "enp"
  },
  {
    "code": "LOE",
    "genre": "F",
    "article": "La",
    "nom_commun": "loche d'étang",
    "type_espece": "eih"
  },
  {
    "code": "LOR",
    "genre": "F",
    "article": "La",
    "nom_commun": "loche de rivière",
    "type_espece": "enp"
  },
  {
    "code": "LOF",
    "genre": "F",
    "article": "La",
    "nom_commun": "loche franche",
    "type_espece": "enp"
  },
  {
    "code": "LOT",
    "genre": "F",
    "article": "La",
    "nom_commun": "lote de rivière",
    "type_espece": "enp"
  },
  {
    "code": "SDF",
    "genre": "M",
    "article": "L'",
    "nom_commun": "omble de fontaine",
    "type_espece": "eih"
  },
  {
    "code": "OBR",
    "genre": "M",
    "article": "L'",
    "nom_commun": "ombre commun",
    "type_espece": "enp"
  },
  {
    "code": "PER",
    "genre": "F",
    "article": "La",
    "nom_commun": "perche",
    "type_espece": "enp"
  },
  {
    "code": "PES",
    "genre": "F",
    "article": "La",
    "nom_commun": "perche soleil",
    "type_espece": "eih"
  },
  {
    "code": "PCH",
    "genre": "M",
    "article": "Le",
    "nom_commun": "poisson chat",
    "type_espece": "eih"
  },
  {
    "code": "PSR",
    "genre": "M",
    "article": "Le",
    "nom_commun": "pseudorasbora",
    "type_espece": "eih"
  },
  {
    "code": "ROT",
    "genre": "M",
    "article": "Le",
    "nom_commun": "rotengle",
    "type_espece": "enp"
  },
  {
    "code": "SAN",
    "genre": "M",
    "article": "Le",
    "nom_commun": "sandre",
    "type_espece": "eih"
  },
  {
    "code": "SIL",
    "genre": "M",
    "article": "Le",
    "nom_commun": "silure glane",
    "type_espece": "eih"
  },
  {
    "code": "SPI",
    "genre": "M",
    "article": "Le",
    "nom_commun": "spirlin",
    "type_espece": "enp"
  },
  {
    "code": "TAN",
    "genre": "F",
    "article": "La",
    "nom_commun": "tanche",
    "type_espece": "enp"
  },
  {
    "code": "TAC",
    "genre": "F",
    "article": "La",
    "nom_commun": "truite arc en ciel",
    "type_espece": "eih"
  },
  {
    "code": "TRF",
    "genre": "F",
    "article": "La",
    "nom_commun": "truite fario",
    "type_espece": "enp"
  },
  {
    "code": "UMP",
    "genre": "M",
    "article": "L'",
    "nom_commun": "umbre pygmée",
    "type_espece": "eih"
  },
  {
    "code": "VAI",
    "genre": "M",
    "article": "Le",
    "nom_commun": "vairon",
    "type_espece": "enp"
  },
  {
    "code": "VAN",
    "genre": "F",
    "article": "La",
    "nom_commun": "vandoise",
    "type_espece": "enp"
  },
  {
    "code": "VAR",
    "genre": "F",
    "article": "La",
    "nom_commun": "vandoise rostrée",
    "type_espece": "eih"
  }
];

function removeAccents(str) {
  let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
  str = str.split('');
  str.forEach((letter, index) => {
    let i = accents.indexOf(letter);
    if (i != -1) {
      str[index] = accentsOut[i];
    }
  })
  return str.join('');
}

function compare_nom_commun(a, b) {
  // TODO: use localeCompare instead of upper + remove accents
  // Use toUpperCase() to ignore character casing
  const nom_commun_a = removeAccents(a.nom_commun.toUpperCase());
  const nom_commun_b = removeAccents(b.nom_commun.toUpperCase());

  let comparison = 0;
  if (nom_commun_a > nom_commun_b) {
    comparison = 1;
  } else if (nom_commun_a < nom_commun_b) {
    comparison = -1;
  }
  return comparison;
}

var especes_sorted_by_nom_commun = Array.prototype.slice.call(especes).sort(compare_nom_commun);

var especes_by_key = especes.reduce((acc, curr) => {
  acc[curr.code.toLowerCase()] = curr.nom_commun;
  return acc;
}, {});

export default {
  name: 'home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      map: '',
      highlight_layer_secteurs: null,
      highlight_layer: null,
      travaux_filters: [
        {lib: 'Restauration de la continuité écologique', value: 'continuite', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération'},
        {lib: 'Restauration de zones humides', value: 'zones_humides', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération'},
        {lib: 'Restauration hydromorphologique', value: 'hydromorphologie', 'filtering': 'type_op', lib_all: 'Tous travaux', lib_title: 'Type d\'opération'},
        {lib: 'Collectivité', value: 'collectivite', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure'},
        {lib: 'Institution', value: 'institution', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure'},
        {lib: 'Privé', value: 'prive', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure'},
        {lib: 'Structure de pêche de loisir', value: 'peche_loisir', 'filtering': 'type_structure', lib_all: 'Toutes structures', lib_title: 'Type de structure'}
      ],
      activateOnceTypeStructure: true,
      checked_rapport: false,
      minDate: 1990,
      maxDate: 2024,
      minSelectedDate: 1990,
      maxSelectedDate: 2024,
      slider: null,
      travaux_layer: null,
      checked_travaux_vector_layer: false,
      draw_travaux: false,
      draw_travaux_evt_key: null,
      firstGroup: firstGroup,
      rivieresGroup: rivieresGroup,
      contextTitle: 'Bassin Seine Normandie',
      current_zoom: 7,
      current_center: [1.834108, 48.528835],
      queryable_layers: [],
      correspondances: [],
      basemap: 'OPENSTREETMAP-CARTO-POSITRON',
      locked_cadenas: false,
      show_couches: false,
      show_poissons: false,
      show_poissons_popup: true,
      show_cours_eau: false,
      show_block_stat: false,
      show_block_interpretation: false,
      show_block_stat_echantillonnage: false,
      show_block_stat_restauration: false,
      show_block_poissons: false,
      show_block_rivieres: false,
      show_block_actions: false,
      show_block_obstacles: false,
      show_toggletopdown_poissons: true,
      show_togglelateral_poissons: true,
      show_toggletopdown_rivieres: true,
      show_toggletopdown_obstacles: true,
      show_block_stations: true,
      show_togglelateral_rivieres: true,
      show_toggletopdown_actions: true,
      show_togglelateral_actions: true,
      show_restauration_ecologique: false,
      show_especes_categories: {
        enp: false,
        eih: false
      },
      selected_especes: [], // 2, 3
      checkboxes_left_menu: {
        checked_stations_echantillonnage: false, // 1
        // checked_qualite_eau: false,
        especes_temps: 'temps_etat__all',
        especes_protocole: 'protocole_full',
        checked_richesse_specifique: false, // 4 (5 non inclus)
        checked_etat_ipr: false, // 6,
        checked_assemblage_pisci_ref: false, // 6bis
        checked_qualite_eau_etat_pc: false, // 7
        checked_qualite_eau_etat_ps: false, // 8
        checked_qualite_eau_bio: false, // 9
        checked_diversite_habitat: false, // 13
        checked_presence_ripisylve: false, // 14,
        checked_erosion_sol: false, // 14bis
        checked_qualite_localisation_obst: false, // 15
        checked_taux_etag: false, // 16
        checked_taux_frac: false, // 17
        checked_prio_restau: false, // 18
        checked_localisation_typologie: false // 20
      },
      handleClickControlPrint: function() {},
      disable_full: false,
      fond_cartes: false,
      left_panel: true,
      right_panel: true,
      legend_panel: false,
      legends: [],
      // show_popup: true,
      popup_element: '',
      popup_travaux: '',
      is_user_logged_in: false,
      textTextArea: '',
      idInfo: '',
      idInfoEvolution: '',
      linkText: '',
      textPdfArea: '',
      idPdf: '',
      external_url: '',
      linkPdfText: '',
      especes: especes_sorted_by_nom_commun,
      baseURL: 'https://www.observatoire-poissons-seine-normandie.fr',
      baseUrlCarto: 'https://www.observatoire-poissons-seine-normandie.fr',
      current_full_url: '',
      // url_article_poisson: undefined,
      // url_image_poisson: undefined,
      pieChartEchantillonnage: null,
      barChartEchantillonnage: null,
      pieChartTravaux: null,
      barChartTravaux: null,
      barChartIPR: null,
      barChartEvolutionSpecies: null,
      pieContextePiscicoleSalmonicole: null,
      pieContextePiscicoleIntermediaire: null,
      pieContextePiscicoleCyprinicole: null,
      commentEvolutionEspeces: null,
      commentRichesseSpecifiqueEvolution: null,
      especesEtatCommentsCache: {},
      especesEtatComments: null,
      layers_background_list: [
        {
          "title": "Satellite",
          "identifier": "ORTHOIMAGERY.ORTHOPHOTOS",
          "format": "image/jpeg",
          "styles": [
            "normal"
          ],
          "opacity": 0.5,
          "type": "WMTS-IGN",
          "picto": "picto-carte-satellite.png",
          "basemap": true
        },
        {
          "title": "Carte IGN",
          "identifier": "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
          "format": "image/png",
          "styles": [
            "normal"
          ],
          "opacity": 0.5,
          "type": "WMTS-IGN",
          "picto": "picto-carte-ign.png",
          "basemap": true
        },
        {
          "title": "OSM",
          "title_alt": "OpenStreetMap",
          "identifier": "OPENSTREETMAP-CARTO-POSITRON",
          "type": "XYZ",
          "url": "https://{a-d}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=cb1_333x_1_8aced4398b94c5fcd4316790",
          "picto": "picto-carte-osm.png",
          "basemap": true
        },
        {
          "title": "Parcelles cadastrales",
          "identifier": "CADASTRALPARCELS.PARCELS",
          "format": "image/png",
          "styles": [
            "normal"
          ],
          "type": "WMTS-IGN",
          "basemap": false
        },
        {
          "title": "Départements",
          "identifier": "departements",
          "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
          "params": {
            "FORMAT": "image/png",
            "VERSION": "1.1.1",
            "STYLES": "departements_bsn_untiled",
            "LAYERS": "general:departements_bsn"
          },
          "type": "WMS-UNTILED",
          "basemap": false
        },
        {
          "title": "Bassins versants",
          "identifier": "bassinsversants",
          "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
          "params": {
            "FORMAT": "image/png",
            "VERSION": "1.1.1",
            "STYLES": "secteurs_bsn_untiled",
            "LAYERS": "general:secteurs_bsn"
          },
          "type": "WMS-UNTILED",
          "basemap": false
        },
        {
          "title": "Cours d'eau",
          "identifier": "courseau_fxx",
          "url": "https://www.observatoire-poissons-seine-normandie.fr/geoserver/general/wms",
          "params": {
            "FORMAT": "image/png",
            "VERSION": "1.1.1",
            "STYLES": "",
            "LAYERS": "general:courseau_fxx"
          },
          "type": "WMS",
          "basemap": false
        }
      ].map(el => {
        el.visible = (['courseau_fxx', 'OPENSTREETMAP-CARTO-POSITRON'].includes(el.identifier));
        return el;
      })
    }
  },
  asyncComputed: {
    async url_article_poisson () {
      let codeEspece = '';
      if (this.selected_especes[0]) {
        codeEspece = this.selected_especes[0].replace('temps_', '');
      }
      let idLayer = this.getIdLayer(codeEspece);
      var matching = this.correspondances.find(el => {
        return el.id == idLayer;
      });
      // debugger;
      if(matching) {
        var id = matching.id.split('_')[1].toLowerCase();
        if (['ccu', 'cmi'].includes(id)) {
          id = 'cco';
        }

        var url = `${this.baseURL}/wp-admin/admin-ajax.php?action=opsn_poisson_get&id=${id}`;
        var url_article = await fetch(url).then(response => {
          return response.json();
        }).then(json => {
          return json.url !== 'false' ? json.url : undefined;
        });
        return url_article;
      } else {
        return undefined;
      }
    },
    async url_image_poisson () {
      let codeEspece;
      if (this.selected_especes.length > 0) {
        codeEspece = this.selected_especes[0].replace('temps_', '');
      } else {
        codeEspece = 'empty';
      }
      let idLayer = this.getIdLayer(codeEspece);
      var matching = this.correspondances.find(el => {
        return el.id == idLayer;
      });
      // debugger;
      if(matching) {
        var id = matching.id.split('_')[1].toLowerCase();
        if (['ccu', 'cmi'].includes(id)) {
          id = 'cco';
        }
        var url = `${this.baseURL}/wp-admin/admin-ajax.php?action=opsn_poisson_get&id=${id}`;
        var url_photo = await fetch(url).then(response => response.json())
        .then(json => {
          return json.photo !== 'false' ? json.photo : undefined;
          // this.url_image_poisson = json.photo !== 'false' ? json.photo : undefined;
          // this.url_article_poisson = json.url !== 'false' ? json.url : undefined;
        })
        return url_photo;
      } else {
        // this.url_article_poisson = undefined;
        // this.url_image_poisson = undefined;
        return undefined;
      }
    }
  },
  computed: {
    title_espece: function() {
      let codeEspece;
      if (this.selected_especes.length > 0) {
        codeEspece = this.selected_especes[0].replace('temps_', '');
      } else {
        codeEspece = 'empty';
      }
      let idLayer = this.getIdLayer(codeEspece);
      var matching = this.correspondances.find(el => {
        return el.id == idLayer;
      });
      if(matching) {
          return matching.layer.title;
      } else {
        return null;
      }
    },
    categories() {
      let tickboxExceptEspeces = Object.keys(this.checkboxes_left_menu)
          .filter(el => !el.startsWith('especes_'))
          .filter(el => this.checkboxes_left_menu[el]);

      let category1 = tickboxExceptEspeces
        .filter(el => el === 'checked_stations_echantillonnage');
      let subCategory1FromCategory2 = tickboxExceptEspeces.filter(el => {
        return [
          'checked_localisation_typologie',
          'checked_stations_echantillonnage'
        ].indexOf(el) === -1;
      });
      let subCategory2FromCategory2 = this.selected_especes.length > 0;

      let category2 = subCategory1FromCategory2.length > 0 || subCategory2FromCategory2;
      let category3 = tickboxExceptEspeces
        .filter(el => el === 'checked_localisation_typologie');

      return [category1.length > 0, [subCategory1FromCategory2.length > 0, subCategory2FromCategory2], category3.length > 0];
    },
    display_evolution_chart() {
      return (this.checkboxes_left_menu.especes_temps === 'temps__evolution' || this.checkboxes_left_menu.especes_temps === 'temps_evolution') && (
      ['protocole_complet', 'protocole_ponctuel', 'protocole_full'].includes(this.checkboxes_left_menu.especes_protocole)
      ) &&
      this.idInfoEvolution &&
      this.barChartEvolutionSpecies && this.barChartEvolutionSpecies.data && this.barChartEvolutionSpecies.data.length > 0;
    },
    display_comment_etat() {
      return /temps[_]*etat/.test(this.checkboxes_left_menu.especes_temps) && (
      this.selected_especes.length > 0)
    },
    display_comment_evolution() {
      return /temps[_]*evolution/.test(this.checkboxes_left_menu.especes_temps) && (
      this.selected_especes.length > 0)
    },
    legend_poisson() {
      // return [];
      if (this.correspondances.length > 0) {
          let filtered = this.correspondances.find(el => {
              return el.id === (this.selected_especes[0] +
                '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '') +
                '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '')
              );
            });
          if (filtered) {
            let legends = [{
              layerLabel: filtered.layer.title_legend || filtered.layer.title,
              layerName: filtered.layer.params.LAYERS
            }];
            let contentLegends = legends.map(el => {
              let keysVals = getLegendGraphicOptions(el.layerName);
              let urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' +
                Object.keys(keysVals).map(key => key + '=' + keysVals[key]).join('&');
              return {
                layerLabel: el.layerLabel,
                layerUrl: urlCouche
              }
            });
            return contentLegends;
          }
        } else {
          return [];
        }
    },
    legend_travaux_restauration() {
      if (this.correspondances.length > 0) {
        let filtered;
        if (this.checkboxes_left_menu.checked_localisation_typologie) {
          filtered = this.correspondances.find(el => el.id === 'checked_localisation_typologie');
          let keysVals = getLegendGraphicOptions(filtered.layer.params.LAYERS);
          let urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' +
            Object.keys(keysVals).map(key => key + '=' + keysVals[key]).join('&');
            return urlCouche;
        }
      }
    },
    legend_to_show() {
      if (this.correspondances.length > 0) {
        let legends = [];
        this.legends = [];
        // Category 1
        if (this.categories[0]) {
          legends.push({
            layerLabel: 'Stations d\'échantillonnage',
            layerName: 'general:stations_echantillonnage'
          });
        }
        // Category 2
        if (this.categories[1][0] || this.categories[1][1]) {
          let filtered;
          let layerObj;
          if (this.categories[1][0]) {
          let tickboxExceptEspeces = Object.keys(this.checkboxes_left_menu)
            .filter(el => !el.startsWith('especes_'))
            .filter(el => this.checkboxes_left_menu[el])
            .filter(el => {
              return [
                'checked_localisation_typologie',
                'checked_stations_echantillonnage'
              ].indexOf(el) === -1;
            });
            filtered = this.correspondances.find(el => el.id === tickboxExceptEspeces[0]);
          }
          if (this.categories[1][1]) {
            filtered = this.correspondances.find(el => {
              return el.id === (this.selected_especes[0] +
                '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '') +
                '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '')
              );
            });
          }
          layerObj = {
            layerLabel: filtered.layer.title_legend || filtered.layer.title,
            layerName: filtered.layer.params.LAYERS
          };
          legends.push(layerObj);
        }
        // Category 3
        if (this.categories[2]) {
          ['checked_localisation_typologie'].forEach(cat3el => {
            if(this.checkboxes_left_menu[cat3el]) {
              let filtered = this.correspondances.find(el => el.id === cat3el);
              legends.push({
                layerLabel: filtered.layer.title_legend || filtered.layer.title,
                layerName: filtered.layer.params.LAYERS
              });
            }
          })
        }

        let contentLegends = legends.map(el => {
          let keysVals = getLegendGraphicOptions(el.layerName);
          let urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' +
            Object.keys(keysVals).map(key => key + '=' + keysVals[key]).join('&');
          return {
            layerLabel: el.layerLabel,
            layerName: urlCouche
          }
        });
        this.legends = legends;
        return contentLegends;
      } else {
        this.legends = [];
        return [];
      }
    }
  },
  watch: {
    show_block_stat_restauration: function(newVal, oldVal) {
      if (newVal) {
        this.mapSetHash();

        if (this.selected_especes.length > 0) {
          this.updateFromContext(true);
        } else {
          this.updateFromContext(false);
        }
      }
    },
    checked_travaux_vector_layer: function(val) {
      this.travaux_layer.setVisible(val);
      if (this.selected_especes.length > 0) {
        this.updateFromContext(val);
      } else {
        this.updateFromContext(val);
      }
    },
    right_panel: function(val) {
      if (!val && this.highlight_layer) {
        this.highlight_layer.getSource().clear();
      }
    },
    travaux_filters: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(val) {
        // If one type of operation ticked among all, show the layer
        if (val && val.filter(filter => filter.filtering == 'type_op').some(filter => filter.checked)) {
          // this.checked_travaux_vector_layer = true;
          this.foldAllExcept('show_toggletopdown_actions');
          // If no filter on type of structure, tick all to be sure to show something
          if (this.activateOnceTypeStructure) {
            if ((val.filter(filter => filter.filtering == 'type_structure' && filter.checked)) == 0) {
              val.filter(filter => filter.filtering == 'type_structure')
              .forEach(element => {
                element.checked = true;
              })
              this.activateOnceTypeStructure = false;
            }
          }

          if (val.some(filter => filter.filtering == 'type_structure' && filter.checked)) {
            this.checked_travaux_vector_layer = true;
          } else {
            this.checked_travaux_vector_layer = false;
          }
          // console.log(this.write_filter_travaux());
          this.travaux_layer.getSource().refresh();
          this.mapSetHash();
        } else {
          this.checked_travaux_vector_layer = false;
          val.filter(filter => filter.filtering == 'type_structure')
          .forEach(element => {
            element.checked = false;
          })
          this.activateOnceTypeStructure = true;
          this.minSelectedDate = this.minDate;
          this.maxSelectedDate = this.maxDate;
          this.slider.range(this.minSelectedDate, this.maxSelectedDate);
          this.checked_rapport = false;
        }
        // this.mapSetHash();
      }
    },
    minSelectedDate: function(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    },
    maxSelectedDate: function(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    },
    checked_rapport: function(val) {
      this.travaux_layer.getSource().refresh();
      this.mapSetHash();
    }
  },
  methods: {
    reInitializeLayers() {
      this.checked_travaux_vector_layer = false;
      // this.resetGroup1();
      this.show_toggletopdown_poissons = false;
      this.show_toggletopdown_rivieres = false;
      this.show_toggletopdown_obstacles = false;
      this.show_toggletopdown_actions = false;

      this.show_block_stat = false;
      this.show_block_interpretation = false;
      this.show_block_stat_echantillonnage = false;
      this.show_block_stat_restauration = false;
      this.show_block_poissons = false;
      this.show_block_rivieres = false;
      this.show_block_actions = false;
      this.show_block_obstacles = false;

      this.selected_especes = [];
      const keys = Object.entries(this.checkboxes_left_menu)
        .filter(([key, value])=> !key.startsWith('especes_'))
      for (let [key, value] of keys) {
        if (value) {
          this.checkboxes_left_menu[key] = false;
        }
      }
      this.travaux_filters.forEach(filter => {
        filter.checked = false;
      });
      this.minSelectedDate = this.minDate;
      this.maxSelectedDate = this.maxDate;
      this.slider.range(this.minSelectedDate, this.maxSelectedDate);
      this.checked_rapport = false;

      this.activateOnceTypeStructure = true;
      this.$forceUpdate();
      this.mapSetHash();
    },
    getIdLayer(codeEspece) {
      let idLayer;
      if (this.checkboxes_left_menu.especes_temps.endsWith('_evolution')) {
         idLayer = 'points' + '_' + codeEspece + '_' + 'stations' +
        '_' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '') +
        '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
      } else {
        idLayer = 'points' + '_' + codeEspece +
        '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[0] +
        '__' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '') +
        '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[1];
      }
      return idLayer;
    },
    findLayerInCorrespondances(key) {
      let copy_key = key;
      if (key === 'checked_richesse_specifique') {
        let parts = this.checkboxes_left_menu.especes_temps.split('__');
        let suffix = 'evolution';
        if (parts.length > 0) {
          [suffix] = parts.slice(-1);
        }
        copy_key = 'richesse_specifique__full__' + suffix;
      }
      if (key === 'checked_etat_ipr') {
        if (this.checkboxes_left_menu.especes_temps.includes('evolution')) {
          this.checkboxes_left_menu.especes_temps = 'temps_etat__all';
        };
        let parts = this.checkboxes_left_menu.especes_temps.split('__');
        const [suffix] = parts.slice(-1);
        copy_key = 'etat_ipr__' + suffix;
      }
      return this.correspondances.find(el => el.id === copy_key);
    },
    zoomToInitialExtent() {
      this.map.getView().fit(extentZoom);
    },
    openInformationsPDF() {
      window.open('static/pdf/regles opsn.pdf');
    },
    copyUrlToClipboard: function() {
      var url =`https://tinyurl.com/api-create.php?url=${encodeURIComponent(this.current_full_url)}`;
      fetch(url)
      .then(response => response.text())
      .then(text => {
        console.log('text', text);
        this.$copyText(text).then(function(e) {
          console.log('Copied', e);
        }, function (e) {
          console.log('Can not copy', e);
        });
      })
    },
    openExternalUrl: function() {
      window.open(this.external_url);
    },
    clickParent(subfilter, typefilter) {
      var filters = this.travaux_filters
        .filter(filter => filter.filtering == typefilter)
        .filter(filter => filter.filtering == subfilter[0].filtering);
      if (filters.find(filter => !filter.checked)) {
        filters.forEach(filter => filter.checked = true);
      } else {
        filters.forEach(filter => filter.checked = false);
      }
    },
    foldAllExcept(show_toggletopdown_key) {
      let keys = [
        'show_toggletopdown_poissons',
        'show_toggletopdown_rivieres',
        'show_toggletopdown_obstacles',
        'show_toggletopdown_actions'
      ];
      for (let key of keys) {
        if (key !== show_toggletopdown_key) {
          this[key] = false;
        } else {
          this[key] = true;
        }
      }
    },
    filters_travaux(filtering) {
      return this.travaux_filters
      .filter(travaux => travaux.filtering == filtering)
        .reduce((acc, curr) => {
        if (!(curr.filtering in acc)) {
          acc[curr.filtering] = [];
        }
        acc[curr.filtering].push(curr);
        return acc;
      }, {});
    },
    filter_travaux_layer_style(feature) {
      const params = this.write_filter_travaux();
      let type_op = true;
      if ('type_op' in params && params['type_op'].length > 0) {
        type_op = params['type_op']
          .includes(feature.get('type_op'));
      }
      let type_structure = true;
      if ('type_structure' in params && params['type_structure'].length > 0) {
        type_structure = params['type_structure']
          .includes(feature.get('type_structure'));
      }
      let fichier = true;
      if ('fichier' in params) {
        fichier = feature.get('fichier').length > 0 || feature.get('url').length > 0;
      }
      let annee_rec = true;
      if ('annee_rec' in params) {
        let [min, max] = params['annee_rec'].split(',');
        annee_rec = feature.get('annee_rec') >= min && feature.get('annee_rec') <= max;
      }
      return type_op && type_structure && fichier && annee_rec;
    },
    write_filter_travaux() {
      const json = this.travaux_filters.reduce((acc, curr) => {
        if (!(curr.filtering in acc)) {
          acc[curr.filtering] = [];
        }
        acc[curr.filtering].push(curr);
        return acc;
      }, {});
      for (let [key, value] of Object.entries(json)) {
        if(value.length > 0) {
          json[key] = value
            .filter(filter => filter.checked)
            .map(element => element.value);
        } else {
          json[key] = [];
        }
      }
      if (this.checked_rapport) {
        json['fichier'] = true;
      }
      if (this.minSelectedDate != this.minDate || this.maxSelectedDate != this.maxDate) {
        json['annee_rec'] = `${this.minSelectedDate},${this.maxSelectedDate}`;
      }
      return json;
    },
    activateDrawingTravaux() {
      if (!this.draw_travaux) {
        this.draw_travaux = true;
        this.right_panel = false;
        this.map.getViewport().style.cursor = this.draw_travaux ? 'crosshair' : '';
        this.draw_travaux_evt_key = this.map.once('click', evt => {
          let [x_l93, y_l93] = ol.proj.transform(evt.coordinate, 'EPSG:3857', proj2154);
          this.draw_travaux = false;
          this.map.getViewport().style.cursor = '';
          window.open(`${this.baseURL}/carte/gestion/?type=action&id=new&x_l93=${x_l93}&y_l93=${y_l93}`);
        });
      } else {
        if (this.draw_travaux_evt_key) {
          ol.Observable.unByKey(this.draw_travaux_evt_key);
        }
        this.draw_travaux = false;
        this.map.getViewport().style.cursor = '';
      }
    },
    resetGroup1() {
      if (this.selected_especes.length > 0) {
        this.selected_especes = [];
      }
      if (this.check_if_first_group()) {
        for (let key of this.firstGroup) {
          if (this.checkboxes_left_menu[key]) {
            this.checkboxes_left_menu[key] = false;
            break;
          }
        }
      }
    },
    resetGroupRivieres() {
      if (this.check_if_rivieres_group()) {
        for (let key of this.rivieresGroup) {
          if (this.checkboxes_left_menu[key]) {
            this.checkboxes_left_menu[key] = false;
            break;
          }
        }
      }
    },
    get_legend_url(idLayer, withScale=false) {
      if (this.correspondances.length > 0) {
        if (idLayer in this.checkboxes_left_menu || this.selected_especes.length > 0) {
          const filtered = this.findLayerInCorrespondances(idLayer);
          if (idLayer === undefined) {
            return '';
          } else {
            const keysVals = getLegendGraphicOptions(filtered.layer.params.LAYERS);
            if (withScale) {
              keysVals['SCALE'] = String(this.mapScale(72));
            }
            let urlCouche = this.baseUrlCarto + '/geoserver/general/wms?' +
              Object.keys(keysVals).map(key => key + '=' + encodeURIComponent(keysVals[key])).join('&');
              return urlCouche;
          }
        }
      }
    },
    set_title_bar_first_group: function() {
      let self1 = this;
      for (let k of self1.firstGroup) {
        if (this.checkboxes_left_menu[k]) {
          let filtered = this.findLayerInCorrespondances(k);
          return filtered.layer.title.split(' — ')[0];
        }
      }
    },
    set_title_bar_rivieres_group: function() {
      let self1 = this;
      for (let k of self1.rivieresGroup) {
        if (this.checkboxes_left_menu[k]) {
          let filtered = this.findLayerInCorrespondances(k);
          return filtered.layer.title.split(' — ')[0];
        }
      }
    },
    check_if_first_group: function() {
      let present = this.firstGroup.filter(key => this.checkboxes_left_menu[key]);
      return present.length > 0;
    },
    check_if_rivieres_group: function() {
      let present = this.rivieresGroup.filter(key => this.checkboxes_left_menu[key]);
      return present.length > 0;
    },
    isGroup1: function() {
      return this.selected_especes.length > 0 ||
             this.check_if_first_group();
    },
    get_first_group_key: function() {
      let present = this.firstGroup.filter(key => this.checkboxes_left_menu[key]);
      if (present.length > 0) {
        return present[0];
      }
    },
    get_rivieres_group_key: function() {
      let present = this.rivieresGroup.filter(key => this.checkboxes_left_menu[key]);
      if (present.length > 0) {
        return present[0];
      }
    },
    switch_left_panel: function() {
      this.left_panel = !this.left_panel;
      // if (this.left_panel && (window.screen.width * window.devicePixelRatio) <= 1024) {
      //   this.right_panel = false;
      // }
    },
    switch_right_panel: function() {
      this.right_panel = !this.right_panel;
      // if (this.right_panel && (window.screen.width * window.devicePixelRatio) <= 1024) {
      //   this.left_panel = false;
      // }
    },
    selectBaseMap: function (identifier) {
      this.basemap = identifier;
      this.map.getLayers().getArray()
        .filter(el => {
          if (el.get('basemap')) {
            return true;
          }
          return false;
        })
        .forEach(el => {
          if (el.get('identifier') === identifier) {
            el.setVisible(true);
          } else {
            if (el.getVisible()) {
              el.setVisible(false);
            }
            // el.setVisible(!el.getVisible());
          }
        });
    },
    checkboxToggle: function (evt) {
      this.map.getLayers().getArray().filter(el => {
        return el.get('identifier') === evt.target.getAttribute('data-identifier');
      }).forEach(el => {
        el.setVisible(!el.getVisible());

        this.layers_background_list
          .filter(el1 => el1.identifier === el.get('identifier'))
          .forEach(el2 => {
            el2.visible = el.getVisible();
          });
      });
    },
    switchFondCartes: function(evt) {
      this.fond_cartes = !this.fond_cartes;
      // this.$refs.scrollmenuleft.clientHeight = 'calc(90% - ' + this.$refs.fondplan.clientHeight + 'px)';
    },
    refreshText: function (layerId, idElement) {
      let idInfo = `${layerId}__n_action__${idElement}`;
      this.idInfo = idInfo;
      // TODO: debug when undefined
      fetch(`${this.baseURL}/wp-admin/admin-ajax.php?action=opsnmap_get&type=info&id=${idInfo}`)
      .then(response => {
        return response.json();
      })
      .then(json => {
        // var textTextArea = '';
        // var linkText = '';
        if ('info' in json && json.info) {
          this.textTextArea = json.info;
          this.linkText = 'Modifier la description';
        } else {
          this.textTextArea = ''; //'<br>Il n\'y a pas de texte associé';
          this.linkText = 'Éditer la description';
        }
        if (window.is_user_logged_in) {
          this.is_user_logged_in = window.is_user_logged_in;
        }
      });
    },
    refreshPdf: function (layerId, idElement) {
      let idPdf = `${layerId}__n_action__${idElement}`;
      this.idPdf = idPdf;
      fetch(`${this.baseURL}/wp-admin/admin-ajax.php?action=opsnmap_get&type=pdf&id=${idPdf}`)
      .then(r => {
        return r.json();
      })
      .catch(error => {
        console.log(error);
      })
      .then(json => {
        if ('file' in json) {
          this.textPdfArea = '<a target="_blank" href="' + json.file +  '">' +
            '<img src="' + json.thumbnail + ' "/>' +
          '</a>';
          this.linkPdfText = "Modifier cette action";
        } else {
          this.textPdfArea = '';
          this.linkPdfText = "Modifier cette action";
        }
        if (window.is_user_logged_in) {
          this.is_user_logged_in = window.is_user_logged_in;
        }
      });
    },
    mapSetHash() {
        let urlParams = {
          path: this.$router.history.current.path
        }

        let params = {};

        let k1 = 'checked_stations_echantillonnage';
        let k2s = ['checked_localisation_typologie'];
        let k3 = 'checked_qualite_localisation_obst';
        let excludeCategory1AndCategory3 = [k1, ...k2s];
        let ks = Object.keys(this.checkboxes_left_menu)
          .filter(el => {
            return excludeCategory1AndCategory3.indexOf(el) === -1
          })
          .filter(el => !el.startsWith('especes_'));
        let layers = [];

        if(this.map.getView().getZoom()) {
          this.current_zoom = this.map.getView().getZoom();
        }
        if (this.map.getView().getCenter()) {
          this.current_center = ol.proj.toLonLat(this.map.getView().getCenter())
            .map(coord => coord.toFixed(5));
        }

        // category 1
        if (this.categories[0]) {
          layers.push(k1);
        }
        // category 2 sub 1
        if (this.categories[1][0]) {
          let result = ks.filter(el => !el.startsWith('especes_'))
          .filter(el => this.checkboxes_left_menu[el])
          .map(el => {
            let copy_k = el;
            if (el === 'checked_richesse_specifique') {
              let parts = this.checkboxes_left_menu.especes_temps.split('__');
              let suffix = 'evolution';
              if (parts.length > 0) {
                [suffix] = parts.slice(-1);
              }
              copy_k = 'richesse_specifique__full__' + suffix;
            }
            if (el === 'checked_etat_ipr') {
              let parts = this.checkboxes_left_menu.especes_temps.split('__');
              const [suffix] = parts.slice(-1);
              copy_k = 'etat_ipr__' + suffix;
            }
            return copy_k;
          });
          layers = [...layers, ...result];
        }
        // category 2 sub 2
        if (this.categories[1][1]) {
          if (this.selected_especes.length > 0) {
            let result = this.getIdLayer(this.selected_especes[0].split('_')[1]).replace('temps_temps_', 'temps_');
            layers.push(result);
          }
        }
        // Category 3
        if (this.categories[2]) {
          layers.push(k2s[0]);
        }

        params['map'] = [this.current_zoom,
          ...this.current_center
        ].join('/');

        if (layers.length > 0) {
          params['layers'] = layers.join(',')
        }
        // debugger;
        let filter_travaux = this.write_filter_travaux();
        for (let col of ['type_op', 'type_structure']) {
          if (col in filter_travaux && filter_travaux[col].length > 0) {
            params[col] = filter_travaux[col].join(',');
          }
        }
        for (let col of ['fichier', 'annee_rec']) {
          if (col in filter_travaux) {
            params[col] = filter_travaux[col];
          }
        }

        urlParams['hash'] = '#' + Object.keys(params).map(key => {
          return [key, params[key]].join('=');
        }).join('&');
        this.$router.push(urlParams);
        this.current_full_url = global.window.location.href;
    },
    mapGetHash() {
      let hash = this.$router.history.current.hash;
      if (hash) {
        let keys_vals = hash.replace('#', '')
          .split('&')
          .reduce((acc, kv) => {
            let kv1 = kv.split('=');
            acc[kv1[0]] = kv1[1];
            return acc;
          }, {});
        if ('map' in keys_vals) {
          let xyz = keys_vals.map.split('/');
          this.current_zoom = Number(xyz[0]);
          this.current_center = xyz.slice(1, 3).map(coord => Number(coord));
        }
        if ('layers' in keys_vals && keys_vals['layers'] !== undefined) {
          let layers = keys_vals['layers'].split(',');
          layers.forEach(layer => {
            // If species
            if (layer.indexOf('temps_') == 0 || layer.indexOf('points_') == 0 || layer.indexOf('pointsnext_') == 0) {
              let layer_no_prefix = layer.replace(/temps[_]*/, '').replace(/pointsnext[_]*/, '').replace(/points[_]*/, '');
              let sub = layer.split('_');
              this.selected_especes.push('temps_' + layer_no_prefix.split('_')[0]);
              let especes_temps;
              let especes_protocole;
              if (layer.includes('evolution')) {
                especes_temps = '_evolution';
                especes_protocole = layer_no_prefix.slice(layer_no_prefix.indexOf(especes_temps) + especes_temps.length + 1, layer_no_prefix.length);
              } else {
                let intermediate = layer_no_prefix.replace(/[a-z]*[_]*/, '').split('__');
                especes_temps = intermediate[0] + '__' + intermediate[2];
                especes_protocole= intermediate[1];
              }
              this.checkboxes_left_menu.especes_temps = 'temps_' + especes_temps;
              this.checkboxes_left_menu.especes_protocole = 'protocole_' + especes_protocole;
            } else if (layer.startsWith('richesse_specifique')) {
              if (layer.includes('evolution')) {
                this.checkboxes_left_menu.especes_temps = 'temps__evolution';
              } else {
                this.checkboxes_left_menu.especes_temps = 'temps_etat__' + layer.split('__').slice(-1);
              }
              this.checkboxes_left_menu.checked_richesse_specifique = true;
            } else if (layer.startsWith('etat_ipr')) {
              this.checkboxes_left_menu.especes_temps = 'temps_etat__' + layer.split('__').slice(-1);
              this.checkboxes_left_menu.checked_etat_ipr = true;
            } else {
              this.checkboxes_left_menu[layer] = true;
            }
          })
        }

        if ('type_op' in keys_vals && keys_vals['type_op'].length > 0) {
          let type_op_s = keys_vals['type_op'].split(',');
          for (let type_op of type_op_s) {
            this.travaux_filters
            .find(filter => filter.value === type_op)
            .checked = true;
          }
        } else {
          this.travaux_filters
            .filter(filter => filter.filtering === 'type_op')
            .forEach(filter => {
              filter.checked = false;
            });
        }

        if ('type_structure' in keys_vals && keys_vals['type_structure'].length > 0) {
          let type_structure_s = keys_vals['type_structure'].split(',');
          for (let type_structure of type_structure_s) {
            this.travaux_filters
            .find(filter => filter.value === type_structure)
            .checked = true;
          }
        } else {
          this.travaux_filters
            .filter(filter => filter.filtering === 'type_op')
            .forEach(filter => {
              filter.checked = false;
            });
        }

        if ('fichier' in keys_vals && keys_vals['fichier'] === 'true') {
          this.checked_rapport = true;
        }
        if ('annee_rec' in keys_vals) {
          let [min, max] = keys_vals['annee_rec'].split(',');
          this.minSelectedDate = min;
          this.maxSelectedDate = max;
        }
      }
    },
    updateChartsEchantillons(id, field) {
      if (this.checkboxes_left_menu.checked_stations_echantillonnage) {
        if (id) {
          this.pieChartEchantillonnage.fetchPieChart(
            `static/piechart/secteur_all_years_${id.toLowerCase()}.json`, field, transformData
          )
          this.barChartEchantillonnage.fetchBarChart(
            `static/barchart/secteur_last_year_${id.toLowerCase()}.json`, field
          )
        } else {
          this.pieChartEchantillonnage.fetchPieChart(
            'static/piechart/circonscription_all_years_01.json', field, transformData
          )
          this.barChartEchantillonnage.fetchBarChart(
            'static/barchart/circonscription_last_year_01.json', field
          )
        }
      }
    },
    updateEspecesEtatComments(libelle, id) {
      if (this.selected_especes.length > 0) {
        let espece = this.selected_especes[0].replace('temps_', '').toLowerCase();
        var article = especes.find(esp => esp.code.toLowerCase()== espece).article;
        if (article !== `L'`) {
          article += ' ';
        }
        var that = this;
        var genre = especes.find(esp => esp.code.toLowerCase() == espece).genre;
        function populateText(json, id, libelle, article, genre) {
          if (json.zones[id]) {
            if (Number(json.zones[id]) > 0) {
              if (id == '01') {
                return `${article}${json.espece} est présent${genre == 'M' ? '' : 'e'} sur ${Number(json.zones[id]).toFixed(2)}%
                des cours d'eau échantillonnés du bassin Seine Normandie`;
              } else {
                return `${article}${json.espece} est présent${genre == 'M' ? '' : 'e'} sur ${Number(json.zones[id]).toFixed(2)}%
                des cours d'eau échantillonnés du ${libelle.replace(/^Le /, '')}`;
              }
            } else {
              if (id == '01') {
                return `${article}${json.espece} n'a pas été identifié${genre == 'M' ? '' : 'e'} sur les cours d'eau échantillonnés du bassin Seine Normandie`;
              } else {
                return `${article}${json.espece} n'a pas été identifié${genre == 'M' ? '' : 'e'} sur les cours d'eau échantillonnés du ${libelle.replace(/^Le /, '')}`;
              }
            }
          } else {
            var nom_commun = especes.find(esp => esp.code.toLowerCase()== espece).nom_commun;
            var bassin;
            if (that.contextTitle === 'Bassin Seine Normandie') {
              bassin = 'bassin Seine Normandie';
            } else if (that.contextTitle.length > 0) {
              bassin = that.contextTitle.replace(/^[lL]e /, '');
            }
            var comment = `${article}${nom_commun} n'a pas été échantillonné${genre == 'M' ? '' : 'e'} sur les cours d'eau du ${bassin}`;
            return comment;
          }
        }
        // On a deja récupéré la donnée
        if (espece in this.especesEtatCommentsCache) {
          this.especesEtatComments = populateText(this.especesEtatCommentsCache[espece], id, libelle, article, genre);
        } else {
          fetch(`static/comments/especes_last_year_${espece}.json`)
            .then(response => response.json())
            .then(json => {
              this.especesEtatCommentsCache[espece] = json;
              this.especesEtatComments = populateText(json, id, libelle, article, genre);
            })
        }
      }
    },
    updateChartsTravaux(id, field) {
      if (this.checked_travaux_vector_layer) {
        if (id) {
          this.pieChartTravaux.fetchPieChart(
            `static/piechart/secteur_travaux_all_years_${id.toLowerCase()}.json`, field, transformData
          )
          this.barChartTravaux.fetchBarChart(
            `static/barchart/secteur_travaux_last_year_${id.toLowerCase()}.json`, field
          )
        } else {
          this.pieChartTravaux.fetchPieChart(
            'static/piechart/circonscription_travaux_all_years_01.json', field, transformData
          )
          this.barChartTravaux.fetchBarChart(
            'static/barchart/circonscription_travaux_last_year_01.json', field
          )
        }
      }
    },
    updateChartsIPR(id) {
      if (this.checkboxes_left_menu.checked_etat_ipr) {
        if (id) {
          let maxY = 30;
          this.barChartIPR.fetchBarChart(
            `static/barchart/secteur_ipr_more_recent_${id.toLowerCase()}.json`,
            maxY
          )
        } else {
          let maxY = 231;
          this.barChartIPR.fetchBarChart(
            'static/barchart/circonscription_ipr_more_recent_01.json', maxY
          )
        }
      }
    },
    updateContextes(id) {
      if (this.checkboxes_left_menu.checked_richesse_specifique) {
        function transformDataTrend(json, field, colors, libelles) {
          // Only if some data in species
          if (json.species.length > 0) {
            var limit = 5;
            let sum = Object.keys(json.species[0]).reduce((acc, curr) => {
              acc += json.species[0][curr];
              return acc;
            }, 0);
            let data = Object.keys(json.species[0]).filter(key => {
              return json.species[0][key] > 0;
            }).map(key => {
              let percentage = ((json.species[0][key] / sum) * 100);
              return {
                name: key,
                count: json.species[0][key],
                percentage: Number.isInteger(percentage) ? percentage : percentage.toFixed(2),
                color: colors[libelles.indexOf(key)]
              }
            }).slice().sort((a, b) => a.count - b.count);
            var orderedData = [
              ...(data.filter(r => +r.percentage >= limit))
            ];
            if (data.filter(r => +r.percentage < limit).length > 0) {
              orderedData = [
                ...orderedData,
                (data.filter(r => +r.percentage < limit)
                  .reduce((acc, curr) => {
                    acc.count = acc.count + curr.count;
                    var percentage = acc.count / sum * 100;
                    acc.percentage = Number.isInteger(percentage) ? percentage : +percentage.toFixed(2);
                    return acc;
                  }, {
                    name: 'Autres', count: 0, percentage: 0, color: '#943126'
                  }))
              ]
            }
            return orderedData;
          } else {
            return [];
          }
        }
        let secteur;
        var protocoles = ['salmonicole', 'intermediaire', 'cyprinicole'];

        if (id) {
          secteur = id;
          protocoles.forEach(protocole => {
            var variable = `pieContextePiscicole${upper(protocole)}`;
            this[variable].fetchPieChart(
              `static/piechart/contexte/contexte_piscicole_secteurs_${secteur.toLowerCase()}__${protocole}.json`,
              undefined,
              transformDataTrend
            );
          })
        } else {
          secteur = '01';
          protocoles.forEach(protocole => {
            var variable = `pieContextePiscicole${upper(protocole)}`;
            this[variable].fetchPieChart(
              `static/piechart/contexte/contexte_piscicole_secteurs_${secteur}__${protocole}.json`,
              undefined,
              transformDataTrend
            );
          })
        }
      }
    },
    updateCommentEvolutionEspeces(id) {
      if (this.selected_especes.length > 0) {
        // var protocole = this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
        var protocole = 'full';
        let espece = this.selected_especes[0].replace('temps_', '').toLowerCase();
        var path = 'static/comments/evolution_secteurs_especes';
        fetch(`${path}/comments_evolution_secteurs_${espece}__${protocole}.json`)
          .then(response => response.json())
          .then(json => {
            var records = json.trends.filter(record => record.code.toLowerCase() === id.toLowerCase());
            records.sort((a, b) => {
              return a.count < b.count;
            });
            var sum_augmentation_diminution = records.reduce((acc, curr) => {
              if (curr.trend !== 'stable') {
                acc = acc + curr.count;
              }
              return acc;
            }, 0);
            var sum_all = records.reduce((acc, curr) => {
              acc = acc + curr.count;
              return acc;
            }, 0);
            var bassin;
            if (this.contextTitle === 'Bassin Seine Normandie') {
              bassin = 'bassin Seine Normandie';
            } else if (this.contextTitle.length > 0) {
              bassin = this.contextTitle.replace(/^[lL]e /, '');
            }
            var especeText = especes.find(esp => esp.code.toLowerCase() == espece).nom_commun;
            var isApostrophe = especes.find(esp => esp.code.toLowerCase() == espece).article == "L'" ?
              true : false;

            if (sum_augmentation_diminution < 10) {
              this.commentEvolutionEspeces = `Les données sont insuffisantes pour déterminer une tendance sur le ${bassin}`;
            } else {
              var countAugmentation = records.find(record => record.trend == 'augmentation').count;
              var countDiminution = records.find(record => record.trend == 'diminution').count;
              if (countAugmentation >= (2/3 * sum_augmentation_diminution)) {
                this.commentEvolutionEspeces = `Les densités d${isApostrophe ? "'" : 'e '}${especeText} sont en augmentation sur les cours d'eau échantillonnés du ${bassin}.`;
              } else {
                if (countDiminution >= (2/3 * sum_augmentation_diminution)) {
                  this.commentEvolutionEspeces = `Les densités d${isApostrophe ? "'" : 'e '}${especeText} sont en diminution sur les cours d'eau échantillonnés du ${bassin}.`;
                } else {
                  this.commentEvolutionEspeces = 'Aucune tendance ne se dégage à cette échelle.';
                }
              }
            }
          })
      }
    },
    updateCommentRichesseSpecifiqueEvolution(id) {
      if (this.checkboxes_left_menu.checked_richesse_specifique == true && this.checkboxes_left_menu.especes_temps.endsWith('__evolution')) {
        var path = 'static/comments/comments_evolution_richesse.json';
        fetch(path)
          .then(response => response.json())
          .then(json => {
            var records = json.trends.filter(record => record.code.toLowerCase() === id.toLowerCase());
            records.sort((a, b) => {
              return a.count < b.count;
            });
            var trend = records[0].trend;
            let textTrend;
            if (trend === 'augmentation') {
              textTrend = 'en augmentation';
            } else if (trend === 'stable') {
              textTrend = 'stable';
            } else if (trend === 'diminution') {
              textTrend = 'en régression';
            }
            var countAugmentation = records.find(r => r.trend == 'augmentation').count;
            var countDiminution = records.find(r => r.trend == 'diminution').count;
            var countStable = records.find(r => r.trend == 'stable').count;
            if (countAugmentation == countDiminution && countDiminution >= countStable) {
              textTrend = 'hétérogène';
            }
            // var annee = records[0].annee;
            var name = records[0].name;
            var bassin = name[0].toLowerCase() + name.slice(1);
            this.commentRichesseSpecifiqueEvolution = `L'évolution de la richesse spécifique est ${textTrend} sur ${bassin}`;
          })
      }
    },
    updateFromContext(withUpdate) {
      if (this.map) {
        let bassinsversants = this.map.getLayers().getArray().find(layer => layer.get('identifier') === 'bassinsversants');
        let layerId = this.selected_especes[0] +
          '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '') +
          '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
        let layerNoProtocole = this.selected_especes[0] +
          '_' + this.checkboxes_left_menu.especes_temps.replace('temps_', '');
        // bassinsversants
        if (this.map.getView().getZoom() > 8) {
            let center3857 = this.map.getView().getCenter();
            let viewResolution = this.map.getView().getResolution();
            let url = bassinsversants.getSource().getGetFeatureInfoUrl(
              center3857, viewResolution,
              'EPSG:3857', {
                // 'INFO_FORMAT': 'application/vnd.ogc.gml',
                'INFO_FORMAT': 'application/json',
                'FEATURE_COUNT': '1',
                'PROPERTYNAME': 'code_sect,libelle,the_geom'
              }
            );
            if (url) {
              fetch(url)
                .then(response => {
                  return response.json();
                })
                .then(json => {
                  if (json.features.length > 0) {
                    let id = json.features[0].properties.code_sect;
                    let libelle = json.features[0].properties.libelle;
                    let geom = (new ol.format.GeoJSON()).readGeometry(json.features[0].geometry)
                    this.highlight_layer_secteurs.getSource().clear();
                    this.highlight_layer_secteurs.getSource().addFeature(new ol.Feature({
                      geometry: geom
                    }));
                    this.contextTitle = libelle;
                    this.updateChartsEchantillons(id, 'structure');
                    this.updateContextes(id);
                    this.updateCommentEvolutionEspeces(id);
                    this.updateCommentRichesseSpecifiqueEvolution(id);
                    this.updateChartsTravaux(id, 'type_op');
                    this.updateChartsIPR(id);
                    this.updateEspecesEtatComments(libelle, id.toLowerCase());
                    if (withUpdate) {
                      let param = layerNoProtocole;
                      if (!layerNoProtocole.endsWith('__evolution')) {
                        param = layerNoProtocole.split('__')[0];
                      }
                      this.refreshText(param, id);
                    }
                  } else {
                    console.log('No result');
                    this.updateChartsEchantillons(undefined, 'structure');
                    this.updateChartsTravaux(undefined, 'type_op');
                    this.updateChartsIPR(undefined);
                    this.updateEspecesEtatComments(undefined, '01');
                  }
                })
            } else {
              console.log('outside');
            }
        } else {
          // circonscription_admin_bsn
          this.highlight_layer_secteurs.getSource().clear();
          this.updateChartsEchantillons(undefined, 'structure');
          this.updateContextes(undefined);
          this.updateCommentEvolutionEspeces('01');
          this.updateCommentRichesseSpecifiqueEvolution('01');
          this.updateChartsTravaux(undefined, 'type_op');
          this.updateChartsIPR(undefined);
          this.updateEspecesEtatComments(undefined, '01');
          if (withUpdate) {
            let param = layerNoProtocole;
            if (!layerNoProtocole.endsWith('__evolution')) {
              param = layerNoProtocole.split('__')[0];
            }
            this.refreshText(param, '-999999999');
          }
          this.contextTitle = 'Bassin Seine Normandie';
        }
      }
    },
    updateHtmlLegendPieChart: function(selector, libelles, colors) {
      document.getElementById(selector).innerHTML = colors.map((color, idx) => {
        return `<div class="legend-element">
          <p class="libelle-name">
            <span class="key-dot" style="background:${color};font-size:14px;">
            </span>
            ${libelles[idx]}
          </p>
        </div>`;
      }).join('');
    },
    onCopy: function (e) {
      console.log('You just copied: ' + e.text);
    },
    onError: function (e) {
      console.log('Failed to copy texts');
    },
    setLegendTitleForSpecificLayers(checkboxes) {
      var specific_layer = this.correspondances.find(el => {
        var filtered = Object.entries(this.checkboxes_left_menu)
        .filter(entry => [
          ...checkboxes
        ].includes(entry[0]) && entry[1]);
        if (filtered.length > 0) {
          return el.id == filtered[0][0];
        }
        return false;
      });
      if (specific_layer) {
        return specific_layer.layer.title_legend;
      }
      return '';
    },
    mapScale(dpi) {
      var unit = this.map.getView().getProjection().getUnits();
      var resolution = this.map.getView().getResolution();
      var inchesPerMetre = 39.37;
      return resolution * ol.proj.METERS_PER_UNIT[unit] * inchesPerMetre * dpi;
    }
  },
  created () {
    // Set checkbox default value for travaux filter
    this.travaux_filters.forEach(filter => {
      this.$set(filter, 'checked', false);
    });

    // Look for every tick box working without combination with other buttons
    let k1 = 'checked_stations_echantillonnage'; // Stations échanti
    let k2s = ['checked_localisation_typologie']; // Restauration eco
    let k3 = 'checked_qualite_localisation_obst'; // Obstacles
    let k4 = [
      'checked_qualite_eau_etat_pc',
      'checked_qualite_eau_etat_ps',
      'checked_qualite_eau_bio',
      'checked_diversite_habitat',
      'checked_presence_ripisylve',
      'checked_erosion_sol',
      'checked_taux_etag',
      'checked_taux_frac',
      'checked_assemblage_pisci_ref'
    ];
    let excludeCategory1AndCategory3 = [k1, ...k2s, k3, ...k4];
    let ksWithEspeces = Object.keys(this.checkboxes_left_menu)
      .filter(el => {
        return excludeCategory1AndCategory3.indexOf(el) === -1
      });
    let ks = ksWithEspeces.filter(el => !el.startsWith('especes_'));

    for (const k of ks) {
      this.$watch(`checkboxes_left_menu.${k}`, (newVal, oldVal) => {

        ks.filter(el => newVal && el !== k)
          .filter(el => this.checkboxes_left_menu[el])
          .forEach(el => {
            this.checkboxes_left_menu[el] = false;
          });
        if (newVal) {
          this.selected_especes = [];
          this.mapSetHash();
          this.foldAllExcept('show_toggletopdown_poissons');
        }
        let copy_k = k;
        if (k === 'checked_richesse_specifique') {
          let parts = this.checkboxes_left_menu.especes_temps.split('__');
          let suffix = 'evolution';
          if (parts.length > 0) {
            [suffix] = parts.slice(-1);
          }
          copy_k = 'richesse_specifique__full__' + suffix;
        }
        if (k === 'checked_etat_ipr') {
          if (this.checkboxes_left_menu.especes_temps.includes('evolution')) {
            this.checkboxes_left_menu.especes_temps = 'temps_etat__all';
          };
          let parts = this.checkboxes_left_menu.especes_temps.split('__');
          const [suffix] = parts.slice(-1);
          copy_k = 'etat_ipr__' + suffix;
        }
        let matchingLayer = this.map.getLayers().getArray()
          .find(layer => layer.get('identifier') == copy_k);
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            this.queryable_layers.push(layerName);
            if (['checked_richesse_specifique', 'checked_etat_ipr'].includes(k)) {
              this.checkboxes_left_menu[k1] = false;
              this.show_block_stat_echantillonnage = false;
            }
          } else {
            this.queryable_layers = this.queryable_layers
              .filter(item => item !== layerName);
          }
          matchingLayer.setVisible(newVal);
        }
      });
      this.right_panel = false;
    }

    for (const k of k4) {
      this.$watch(`checkboxes_left_menu.${k}`, (newVal, oldVal) => {
        k4.filter(el => newVal && el !== k)
          .filter(el => this.checkboxes_left_menu[el])
          .forEach(el => {
            this.checkboxes_left_menu[el] = false;
          });
        if (newVal) {
          this.mapSetHash();
          this.foldAllExcept('show_toggletopdown_rivieres');
        }
        let matchingLayer = this.map.getLayers().getArray()
          .find(layer => layer.get('identifier') == k);
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            this.queryable_layers.push(layerName);
          } else {
            this.queryable_layers = this.queryable_layers
              .filter(item => item !== layerName);
          }
          matchingLayer.setVisible(newVal);
        }
      });
      this.right_panel = false;
    }

    this.$watch(`checkboxes_left_menu.${k1}`, (newVal, oldVal) => {
      let matchingLayer = this.map.getLayers().getArray()
        .find(layer => layer.get('identifier') == k1);
      if (matchingLayer) {
        // LAYERS can contain more than one layer, comma separated
        // but the application has only one layer.
        var layerName = matchingLayer.getSource().getParams()['LAYERS'];
        if (newVal) {
          this.queryable_layers.push(layerName);
          this.mapSetHash();
          this.updateFromContext(false);
          this.foldAllExcept('show_toggletopdown_poissons');
          this.selected_especes = [];
          this.checkboxes_left_menu.checked_richesse_specifique = false;
          this.checkboxes_left_menu.checked_etat_ipr = false;
        } else {
          this.queryable_layers = this.queryable_layers
            .filter(item => item !== layerName);
        }
        matchingLayer.setVisible(newVal);
      }
      this.right_panel = false;
    });


    k2s.forEach(k2 => {
      this.$watch(`checkboxes_left_menu.${k2}`, (newVal, oldVal) => {
        let matchingLayer = this.map.getLayers().getArray()
          .find(layer => layer.get('identifier') == k2);
        if (matchingLayer) {
          // LAYERS can contain more than one layer, comma separated
          // but the application has only one layer.
          var layerName = matchingLayer.getSource().getParams()['LAYERS'];
          if (newVal) {
            this.queryable_layers.push(layerName);
            this.mapSetHash();
            this.textPdfArea = '';
            this.idPdf = '';
          } else {
            this.queryable_layers = this.queryable_layers
              .filter(item => item !== layerName);
          }
          matchingLayer.setVisible(newVal);
        }
        this.right_panel = false;
      });
    })

    this.$watch(`checkboxes_left_menu.${k3}`, (newVal, oldVal) => {
      let matchingLayer = this.map.getLayers().getArray()
        .find(layer => layer.get('identifier') == k3);
      if (matchingLayer) {
        // LAYERS can contain more than one layer, comma separated
        // but the application has only one layer.
        var layerName = matchingLayer.getSource().getParams()['LAYERS'];
        if (newVal) {
          this.queryable_layers.push(layerName);
          this.mapSetHash();
          // this.updateFromContext(false);
          this.foldAllExcept('show_toggletopdown_obstacles');
        } else {
          this.queryable_layers = this.queryable_layers
            .filter(item => item !== layerName);
        }
        matchingLayer.setVisible(newVal);
      }
      this.right_panel = false;
    });

    var codesEspeces = especes.map(espece => espece.code.toLowerCase());

    this.$watch('selected_especes', (newVal, oldVal) => {
        var toTick;
        if (newVal.length > 1) {
          toTick = newVal.filter(el => oldVal.indexOf(el) === -1);
          this.selected_especes = toTick;
        } else {
          toTick = newVal;
        }
        if (newVal.length > 0) {
          this.foldAllExcept('show_toggletopdown_poissons');
          this.checkboxes_left_menu[k1] = false;
          this.show_block_stat_echantillonnage = false;
        }
        codesEspeces.forEach(codeEspece => {
          let visible = toTick.map(val => val.replace('temps_', '')).indexOf(codeEspece) !== -1;
          let idLayer = this.getIdLayer(codeEspece);

          let matchingLayer = this.map.getLayers().getArray()
            .find(layer => layer.get('identifier') == idLayer);
            // console.log('matchingLayer', matchingLayer ? matchingLayer.get('identifier') : undefined);
          if (matchingLayer) {
            var layerName = matchingLayer.getSource().getParams()['LAYERS'];
            if (visible) {
              this.queryable_layers.push(layerName);
              this.mapSetHash();
            } else {
              this.queryable_layers = this.queryable_layers
                 .filter(item => item !== layerName);
            }
            matchingLayer.setVisible(visible);
          }
        });
        if (this.barChartEvolutionSpecies) {
          this.barChartEvolutionSpecies.data = [];
        }

      // Unchecked all except echantillonnage
      if (newVal.length > 0) {
          Object.keys(this.checkboxes_left_menu)
          .filter(el => !el.startsWith('especes_') &&
            el !== 'checked_stations_echantillonnage' &&
            el !== 'checked_localisation_typologie' &&
            el !== 'checked_qualite_localisation_obst' &&
            !k4.includes(el))
          .filter(el => this.checkboxes_left_menu[el])
          .forEach(el => {
              this.checkboxes_left_menu[el] = false;
          });
          this.updateFromContext(true);
      } else {
        this.idInfo = '';
        this.updateFromContext(false);
      }
      this.right_panel = false;
    })

    var regexTempsEtatFull = /^temps_[a-z]{3}_etat_full/gm;
    let ksEspecesOnly = ksWithEspeces.filter(el => el.startsWith('especes_'));
    ksEspecesOnly.forEach(kEspece => {
      this.$watch(`checkboxes_left_menu.${kEspece}`, (newVal, oldVal) => {
        // To manage disabling full when evolution
        // if (newVal == 'temps_evolution') {
        //   if (this.checkboxes_left_menu.especes_protocole == 'protocole_full') {
        //     this.checkboxes_left_menu.especes_protocole = 'protocole_complet';
        //   }
        //   this.disable_full = true;
        // } else if (newVal == 'temps_etat') {
        //   this.disable_full = false;
        // }

        if (this.selected_especes.length > 0) {
          let oldIdLayer;
          // console.log("DEBUG");
          let codeEspece = this.selected_especes[0].replace('temps_', '');
          if (kEspece.indexOf('_temps') > 0) {
            if (oldVal.endsWith('_evolution')) {
               oldIdLayer = 'points' + '_' + codeEspece + '_' + 'stations' +
              '_' + oldVal.replace(/temps[_]*/g, '') +
              '_' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
            } else {
              oldIdLayer = 'points' + '_' + codeEspece +
              '__' + oldVal.replace(/temps[_]*/g, '').split('__')[0] +
              '__' + this.checkboxes_left_menu.especes_protocole.replace('protocole_', '') +
              '__' + oldVal.replace(/temps[_]*/g, '').split('__')[1];
            }
          }
          if (kEspece.indexOf('_protocole') > 0) {
            if (this.checkboxes_left_menu.especes_temps.endsWith('_evolution')) {
               oldIdLayer = 'points' + '_' + codeEspece + '_' + 'stations' +
              '_' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '') +
              '_' + oldVal.replace('protocole_', '');
            } else {
              oldIdLayer = 'points' + '_' + codeEspece +
              '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[0] +
              '__' + oldVal.replace('protocole_', '') +
              '__' + this.checkboxes_left_menu.especes_temps.replace(/temps[_]*/g, '').split('__')[1];
            }
          }
          let idLayer = this.getIdLayer(codeEspece.replace('temps_', ''));
          let matchingLayer = this.map.getLayers().getArray()
            .find(layer => layer.get('identifier') == idLayer);
          if (matchingLayer) {
            let layerName = matchingLayer.getSource().getParams()['LAYERS'];
            matchingLayer.setVisible(true);
            if (!this.queryable_layers.includes(layerName)) {
              this.queryable_layers.push(layerName);
            }
            this.mapSetHash();
          }
          let matchingOldLayer = this.map.getLayers().getArray()
            .find(layer => layer.get('identifier') == oldIdLayer);
          if (matchingOldLayer) {
            let oldLayerName = matchingOldLayer.getSource().getParams()['LAYERS'];
            this.queryable_layers = this.queryable_layers
              .filter(item => item !== oldLayerName);
            matchingOldLayer.setVisible(false);
          }

          if (newVal == 'temps_evolution' || newVal == 'temps__evolution') {
            var toClean = this.map.getLayers().getArray()
              .find(layer => {
                return layer.getVisible() &&
                       layer.get('identifier') !== undefined &&
                       layer.get('identifier').match(regexTempsEtatFull);
              });
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              this.queryable_layers = this.queryable_layers
                .filter(item => item !== oldLayerNameToClean);
              toClean.setVisible(false);
            }
          }
          this.updateFromContext(true);
        }
        if (this.checkboxes_left_menu.checked_richesse_specifique) {
          function getRichesseIdLayer(val) {
            let parts = val.split('__');
            let suffix = 'evolution';
            if (parts.length > 0) {
              [suffix] = parts.slice(-1);
            }
            return 'richesse_specifique__full__' + suffix;
          }
          if (kEspece.indexOf('_temps') > 0) {
            var toClean = this.map.getLayers().getArray().find(layer => {
              return layer.getVisible() &&
                     layer.get('identifier') !== undefined &&
                     layer.get('identifier') === getRichesseIdLayer(oldVal);
            })
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              this.queryable_layers = this.queryable_layers
                .filter(item => item !== oldLayerNameToClean);
              toClean.setVisible(false);
            }
            var toShow = this.map.getLayers().getArray().find(layer => {
              return layer.get('identifier') !== undefined &&
                     layer.get('identifier') === getRichesseIdLayer(newVal);
            });
            if (toShow) {
              let layerName = toShow.getSource().getParams()['LAYERS'];
              if (!this.queryable_layers.includes(layerName)) {
                this.queryable_layers.push(layerName);
              }
              toShow.setVisible(true);
            }
            this.mapSetHash();
          }
        }
        if (this.checkboxes_left_menu.checked_etat_ipr) {
          function getEtatIprIdLayer(val) {
            let parts = val.split('__');
            const [suffix] = parts.slice(-1);
            return 'etat_ipr__' + suffix;
          }
          if (kEspece.indexOf('_temps') > 0) {
            var toClean = this.map.getLayers().getArray().find(layer => {
              return layer.getVisible() &&
                     layer.get('identifier') !== undefined &&
                     layer.get('identifier') === getEtatIprIdLayer(oldVal);
            })
            if (toClean) {
              var oldLayerNameToClean = toClean.getSource().getParams()['LAYERS'];
              this.queryable_layers = this.queryable_layers
                .filter(item => item !== oldLayerNameToClean);
              toClean.setVisible(false);
            }
            var toShow = this.map.getLayers().getArray().find(layer => {
              return layer.get('identifier') !== undefined &&
                     layer.get('identifier') === getEtatIprIdLayer(newVal);
            });
            if (toShow) {
              let layerName = toShow.getSource().getParams()['LAYERS'];
              if (!this.queryable_layers.includes(layerName)) {
                this.queryable_layers.push(layerName);
              }
              toShow.setVisible(true);
            }
            this.mapSetHash();
          }
        }
        this.right_panel = false;
      });
    });
  },
  mounted: function() {

    var iconZoomToExtendSpan = document.createElement('span');
    var iElement = document.createElement('i');
    iElement.className = 'fa fa-home';
    iElement.setAttribute('aria-hidden', 'true');
    iconZoomToExtendSpan.appendChild(iElement);

    var self = this;
    var map = this.map = new ol.Map({
      target: 'map',
      logo: false,
      // view: view,
      controls: ol.control.defaults({
        attributionOptions: {
          collapsible: false,
          collapsed: false
        },
        attribution: true,
        zoomOptions: {
          zoomInTipLabel: 'Zoom avant',
          zoomOutTipLabel: 'Zoom arrière'
        }
      }).extend([
        // scaleLineControl,
        new ol.control.ZoomToExtent({
          label: iconZoomToExtendSpan,
          extent: extentZoom,
          tipLabel: 'Vue initiale'
        })
      ])
    });

    // Format result in the search input autocomplete
    var formatResult = function(feature, el) {
        var title = document.createElement('strong');
        el.appendChild(title);
        var detailsContainer = document.createElement('small');
        el.appendChild(detailsContainer);
        var details = [];
        title.innerHTML = feature.properties.label || feature.properties.name;
        var types = {
            housenumber: 'numéro',
            street: 'Rue',
            locality: 'Lieu-dit',
            hamlet: 'Hameau',
            village: 'Village',
            city: 'Ville',
            municipality: 'Commune',
            river: 'Cours d\'eau'
        };
        if (types[feature.properties.type]) {
          var spanType = document.createElement('span');
          spanType.className = 'type';
          title.appendChild(spanType);
          spanType.innerHTML = types[feature.properties.type];
        }
        if (feature.properties.city && feature.properties.city !== feature.properties.name) {
          details.push(feature.properties.city);
        }
        if (feature.properties.context) {
          details.push(feature.properties.context);
        }
        detailsContainer.innerHTML = details.join(', ');
    };

    // We reused the default function to center and zoom on selected feature.
    // You can make your own. For instance, you could center, zoom
    // and add a point on the map
    function onSelected(feature) {
      let featureBounds = feature.properties.bounds;
      featureBounds = featureBounds.split(',').map(s => +s);
      // var coordinates = ol.proj.transform(
      //   [feature.geometry.coordinates[0], feature.geometry.coordinates[1]],
      //   'EPSG:4326',
      //   map.getView().getProjection()
      // );
      var fromLonLatToMercator = ol.proj.getTransform('EPSG:4326', map.getView().getProjection());
      // very approximate calculation of projection extent
      var extent3857 = ol.extent.applyTransform(featureBounds, fromLonLatToMercator);
      map.getView().fit(extent3857);
      // map.getView().setCenter(coordinates);
      // map.getView().setZoom(16);
    }

    // URL for API
    var API_URL = `${this.baseUrlCarto}/mysearch`;

    // Create search by adresses component
    var container = new Photon.Search(map, {
      resultsHandler: function() {},
      onSelected: onSelected,
      width: 230,
      placeholder: 'Commune ou cours d\'eau',
      formatResult: formatResult,
      url: API_URL + '/search/?',
      position: 'topright',
      feedbackEmail: null
    });

    var searchBox = document.getElementById('search-box');
    searchBox.appendChild(container);

    var canvasTitleControl = new ol.control.CanvasTitle();
    map.addControl(canvasTitleControl);

    var scaleLineControl = new ol.control.CanvasScaleLine();
    map.addControl(scaleLineControl);
    scaleLineControl.element.style.visibility = '';
    map.renderSync();

    var canvasAttributionControl = new ol.control.CanvasAttribution();
    map.addControl(canvasAttributionControl);

    var handleClickControlPrint = self.handleClickControlPrint = function() {
      canvasAttributionControl.setCanvas(true);
      scaleLineControl.element.style.visibility = 'hidden';
      var title;
      if (self.legends.length > 0) {
        title = self.legends[0].layerLabel;
      } else {
        title = 'Bassin Seine Normandie';
      }
      canvasTitleControl.setTitle(title);
      map.once('postcompose', function(event) {
        var canvas = event.context.canvas;
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(canvas.msToBlob(), 'map.png');
        } else {
          canvas.toBlob(function(blob) {
            saveAs(blob, 'map.png');
          });
        }
      });
      map.renderSync();
      scaleLineControl.element.style.visibility = '';
      canvasAttributionControl.setCanvas(false);
      canvasTitleControl.setTitle('');
      map.renderSync();
    }

    var tileGrid = new ol.tilegrid.WMTS({
      origin: [-20037508, 20037508],
      resolutions: resolutions,
      matrixIds: matrixIds
    });

    this.layers_background_list.forEach(el => {

      if (el.type === 'WMTS-IGN') {
        var ign_source = new ol.source.WMTS({
          url: 'https://data.geopf.fr/wmts',
          layer: el.identifier,
          matrixSet: 'PM',
          format: el.format,
          projection: 'EPSG:3857',
          tileGrid: tileGrid,
          style: el.styles[0],
          attributions: [new ol.Attribution({
            html: '<a href="http://www.geoportail.fr/" target="_blank">' +
                'IGN-Fr/Géoportail</a>'
          })],
          crossOrigin: 'anonymous'
        });

        var ign = new ol.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: ign_source,
          visible: el.visible,
          opacity: el.opacity || 1
        });

        map.addLayer(ign);
      } else if (el.type === 'XYZ') {
        // Detect if retina
        var retina = window.devicePixelRatio > 1;
        var url_xyz = el.url.replace('{r}', '@' + (retina ? '2' : '1') + 'x');
        var ign_source = new ol.source.XYZ({
          url: url_xyz,
          attributions: [new ol.Attribution({
            html: '&copy; Les contributeurs <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
          })],
          tilePixelRatio: retina ? 2 : 1,
          maxZoom: 19,
          crossOrigin: 'anonymous'
        });

        var ign = new ol.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: ign_source,
          visible: el.visible,
          opacity: el.opacity || 1
        });

        map.addLayer(ign);
      } else if (el.type === 'WMS-UNTILED') {
        // WMS at the moment
        var sourceWMS = new ol.source.ImageWMS({
          url: el.url,
          params: el.params,
          serverType: 'geoserver',
          crossOrigin: 'anonymous'
        });
        let wms = new ol.layer.Image({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: sourceWMS,
          visible: el.visible
        });
        map.addLayer(wms);
      } else {
        el.params['TILED'] = true;
        var sourceWMS = new ol.source.TileWMS({
          url: el.url,
          params: el.params,
          serverType: 'geoserver',
          crossOrigin: 'anonymous'
        });
        let wms = new ol.layer.Tile({
          identifier: el.identifier,
          title: el.title,
          basemap: el.basemap,
          source: sourceWMS,
          visible: el.visible
        });
        map.addLayer(wms);
      }
    });

    var element = document.getElementById('map');

    map.on('moveend', evt => {
      // Set hash
      this.mapSetHash();

      if (this.selected_especes.length > 0) {
        this.updateFromContext(true);
      } else {
        this.updateFromContext(false);
      }
    });

    fetch('static/correspondances.json')
    .then(response => response.json())
    .then(json => {
      this.correspondances = [...json].reverse();
      [...this.correspondances].sort(function(obj1, obj2) {
        return obj2.layer.geometry - obj1.layer.geometry;
      }).forEach(el => {
        // WMS at the moment
        el.layer.params['TILED'] = true;
          var sourceWMS = new ol.source.TileWMS({
            url: el.layer.url,
            params: el.layer.params,
            ratio: 1,
            serverType: 'geoserver',
            crossOrigin: 'anonymous'
          });
          let wms = new ol.layer.Tile({
            identifier: el.id,
            source: sourceWMS,
            visible: el.layer.visible
          });
          map.addLayer(wms);
      });

      this.mapGetHash();
      var view = new ol.View({
        center: ol.proj.fromLonLat(this.current_center),
        zoom: this.current_zoom,
        maxZoom: 18
      });

      map.setView(view);

      // view.setCenter(ol.proj.fromLonLat(this.current_center));
      // view.setZoom(this.current_zoom);

      var sourceWmsCirconscription = new ol.source.TileWMS({
        url: this.baseUrlCarto + '/geoserver/general/wms',
        params: {
          "FORMAT": "image/png",
          "VERSION": "1.1.1",
          "STYLES": "",
          "LAYERS": "general:circonscription_admin_bsn"
        },
        serverType: 'geoserver',
        crossOrigin: 'anonymous',
        attributions: 'Observatoire Poissons Seine Normandie'
      });
      var wmsCirconscription = new ol.layer.Tile({
        identifier: 'circonscription_admin_bsn',
        source: sourceWmsCirconscription
      });
      map.addLayer(wmsCirconscription);

      var iconStyleNoPdf = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action.svg'
        }))
      });

      var iconStyleNoPdfHighZoom = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-high-zoom.svg'
        }))
      });

      var iconStyleWithPdf = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-url-plus.svg'
        }))
      });

      var iconStyleWithPdfHighZoom = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-action-url-plus-high-zoom.svg'
        }))
      });

      var filterTypeOpColors = [
        ['continuite', '#fc8d62'],
        ['zones_humides','#8da0cb'],
        ['hydromorphologie', '#66c2a5']
      ];

      var typeResolutions = [['high', 9], ['low', 12]];

      var iconStyleStationsLow = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-station-institution-medium-@2x.svg'
        }))
      });

      var iconStyleStationsMedium = new ol.style.Style({
        image: new ol.style.Icon(/** @type {olx.style.IconOptions} */ ({
          anchor: [0.5, 0.5],
          anchorXUnits: 'fraction',
          anchorYUnits: 'fraction',
          src: 'static/img/picto-station-institution-small-@2x.svg'
        }))
      });

      var combinations = {};
      for (let typeOp of filterTypeOpColors) {
        combinations[typeOp[0]] = {};
        for (let typeResolution of typeResolutions) {
          combinations[typeOp[0]][typeResolution[0]] = new ol.style.Style({
            image: new ol.style.Circle({
              radius: typeResolution[1],
              snapToPixel: false,
              fill: new ol.style.Fill({
                color: typeOp[1]
              }),
              stroke: new ol.style.Stroke({
                color: 'black', width: 1
              })
            })
          });
        }
      }

      var combinationsTravauxHighlight = {};
      for (let typeResolution of typeResolutions) {
        combinationsTravauxHighlight[typeResolution[0]] = new ol.style.Style({
          image: new ol.style.Circle({
            radius: typeResolution[1],
            snapToPixel: false,
            fill: new ol.style.Fill({
              color: [0, 0, 0, 0]
            }),
            stroke: new ol.style.Stroke({
              color: '#ffff00', width: 2
            })
          })
        });
      }

      let empty_style = new ol.style.Style({});
      let travaux_layer_style = function(filter_feature) {
        return function(feature, resolution) {
          var typeResolution = resolution > 310;
          var typeResolutionName = typeResolution ? 'high': 'low';
          if (filter_feature(feature)) {
            let pdf;
            let myStyle = [];
            let type_op = feature.get('type_op');

            myStyle.push(combinations[type_op][typeResolutionName]);

            if (feature.get('fichier').length > 0 || feature.get('url').length > 0) {
              if (typeResolution) {
                myStyle.push(iconStyleWithPdfHighZoom);
              } else {
                myStyle.push(iconStyleWithPdf);
              }
            } else {
              if (typeResolution) {
                myStyle.push(iconStyleNoPdfHighZoom);
              } else {
                myStyle.push(iconStyleNoPdf);
              }
            }
            return myStyle;
          } else {
            return empty_style;
          }
        }
      };
      var travaux_layer_source = new ol.source.Vector();
      let travaux_layer = this.travaux_layer = new ol.layer.Vector({
        source: travaux_layer_source,
        visible: false,
        style: travaux_layer_style(self.filter_travaux_layer_style)
      });
      travaux_layer.set('identifier', 'travaux');
      map.addLayer(travaux_layer);

      const csvUrl = `${this.baseURL}/feed/actions/`;
      fetch(csvUrl).then(response => response.text()).then(text => {
        csv2geojson.csv2geojson(text, {
          latfield: 'y_l93',
          lonfield: 'x_l93',
          delimiter: ';'
        }, function(err, data) {
          // After data reception, add features to the empty vector layer
          var geoJsonFormat = new ol.format.GeoJSON();
          var features = geoJsonFormat.readFeatures(
            data, {
              dataProjection: proj2154,
              featureProjection: 'EPSG:3857'
            }
          );
          travaux_layer_source.addFeatures(features);
          self.mapSetHash();
        });
      });

      // Part to highlight features from GetFeatureInfo
      var fill_highlight_layer = new ol.style.Fill({
        color: 'rgba(255,255,0,0.0)'
      });
      var stroke_highlight_layer = new ol.style.Stroke({
        color: '#ffff00',
        width: 1.5
      });
      let style_highlight_layer = new ol.style.Style({
        image: new ol.style.Circle({
          fill: fill_highlight_layer,
          stroke: stroke_highlight_layer,
          radius: 5
        }),
        fill: fill_highlight_layer,
        stroke: stroke_highlight_layer
      });

      let travaux_layer_style_highlight = function(feature, resolution) {
        var typeResolution = resolution > 310;
        var typeResolutionName = typeResolution ? 'high': 'low';
        return combinationsTravauxHighlight[typeResolutionName];
      }
      let stations_layer_style_highlight = function(feature, resolution) {
        var typeResolution = resolution > 310;
        let simpleImage;
        if (typeResolution) {
          simpleImage = iconStyleStationsMedium;
        } else {
          simpleImage = iconStyleStationsLow;
        }
        return simpleImage;
      }
      var highlight_layer_source = new ol.source.Vector();

      let highlight_layer = this.highlight_layer = new ol.layer.Vector({
        source: highlight_layer_source,
        visible: true,
        style: function(feature, resolution) {
          if (feature.get('identifier') == 'travaux') {
            return travaux_layer_style_highlight(feature, resolution);
          } else if (feature.get('identifier') == 'checked_stations_echantillonnage') {
            return stations_layer_style_highlight(feature, resolution);
          } else {
            return style_highlight_layer;
          }
        }
      });
      map.addLayer(highlight_layer);

      // Part for highlightning secteurs
      let style_highlight_layer_secteurs = new ol.style.Style({
        fill: new ol.style.Fill({
          color: 'rgba(255, 255, 255, 0)'
        }),
        stroke: new ol.style.Stroke({
          color: '#319FD3',
          width: 3
        })
      });

      var highlight_layer_secteurs_source = new ol.source.Vector();

      let highlight_layer_secteurs = this.highlight_layer_secteurs = new ol.layer.Vector({
        source: highlight_layer_secteurs_source,
        visible: true,
        style: style_highlight_layer_secteurs
      });
      map.addLayer(highlight_layer_secteurs);

      var regexLayers = /LAYERS=([\da-zA-Z_:,%]*)/;
      var regexQueryLayers = /QUERY_LAYERS=([\da-zA-Z_:,%]*)/;

      map.on('click', evt => {
        if (!this.draw_travaux) {
          if (evt.dragging) {
            return;
          }
          var viewResolution = (map.getView().getResolution());
          var url = sourceWmsCirconscription.getGetFeatureInfoUrl(
            evt.coordinate, viewResolution,
            'EPSG:3857', {
              'INFO_FORMAT': 'application/vnd.ogc.gml',
              'FEATURE_COUNT': '20'
            }
          );
          var featureTravaux;
          if (this.checked_travaux_vector_layer) {
            var featureTravaux = map.forEachFeatureAtPixel(evt.pixel, function(feat, l) {
              if (l.get('identifier') == 'travaux') {
                return feat;
              }
            });
            if (featureTravaux) {
              let nAction = featureTravaux.get('id').replace('checked_localisation_typologie__n_action__', '');
              self.refreshPdf('checked_localisation_typologie', nAction);
              const template_travaux = "<b>{{type_op}}</b><br>{{m_ouvrage}}, {{annee_rec}}<br><i>{{n_travaux}}</i>";
              self.popup_travaux = micromustache.render(
                template_travaux, {
                  type_op: self.travaux_filters.find(travaux => travaux.value == featureTravaux.get('type_op')).lib,
                  annee_rec: featureTravaux.get('annee_rec'),
                  m_ouvrage: featureTravaux.get('m_ouvrage'),
                  n_travaux: featureTravaux.get('n_travaux')
                }
              );
              self.external_url = featureTravaux.get('url');
            } else {
              self.textPdfArea = '';
                    self.idPdf = '';
              self.popup_travaux = '';
              self.external_url = '';
            }
          } else {
            self.textPdfArea = '';
            self.popup_travaux = '';
            self.external_url = '';
          }
          // Si on peut faire l'appel
          if (url) {
            var myFeatures = [];
            if (self.layers_background_list.find(layer => layer.identifier === 'courseau_fxx').visible) {
              self.queryable_layers = ['general:courseau_fxx', ...self.queryable_layers];
            } else {
              self.queryable_layers = self.queryable_layers.filter(layer => layer !== 'general:courseau_fxx');
            }

            if (featureTravaux) {
              var featureTravauxCopy = featureTravaux.clone();
              featureTravauxCopy.set('identifier', 'travaux');
              myFeatures.push(featureTravauxCopy);
              this.highlight_layer.getSource().clear();
              this.highlight_layer.getSource().addFeatures(myFeatures);
              self.right_panel = true;
            } else {
              this.highlight_layer.getSource().clear();
            }

            if (self.queryable_layers.length > 0) {
              self.queryable_layers = Array.from(new Set(self.queryable_layers));
              let stringReplacement = self.queryable_layers
                .map(el => window.encodeURIComponent(el))
                .join(',');
              var layersWms = regexLayers.exec(url);
              var queryLayersWms = regexQueryLayers.exec(url);
              url = url
                .replace(layersWms[1], stringReplacement)
                .replace(queryLayersWms[1], stringReplacement);
              var features = {};

              // Faire l'appel au WMS GetFeatureInfo
              fetch(url).then(response => response.text())
                .then(text => {
                  self.queryable_layers.forEach(layer => {
                    features[layer] = new ol.format.WMSGetFeatureInfo({
                      layers: [layer]
                    }).readFeatures(text);
                  });

                  // Pour les espèces en évolution
                  var evolutionSpeciesLayer = self.queryable_layers.find(el => {
                    return (el.startsWith('general:points_') || el.startsWith('general:pointsnext_')) && (
                    el.endsWith('_evolution_complet') |
                    el.endsWith('_evolution_ponctuel') |
                    el.endsWith('_evolution_full'))
                  });

                  if (evolutionSpeciesLayer) {
                    let featureSpecies = new ol.format.WMSGetFeatureInfo({
                      layers: [evolutionSpeciesLayer]
                    }).readFeatures(text);
                    featureSpecies = featureSpecies
                      .filter(feature => feature.getId().split('.')[0] == evolutionSpeciesLayer.split(':')[1] )

                    if (featureSpecies.length > 0) {
                      let cluster_id = featureSpecies[0].get('cluster_id');
                      var protocole = self.checkboxes_left_menu.especes_protocole.replace('protocole_', '');
                      self.barChartEvolutionSpecies.fetchBarChart(
                        `static/barchart/evolution_density/evolution_density_species_${protocole}_${cluster_id.toLowerCase()}.json`,
                        'agg_den_' + self.selected_especes[0].replace('temps_', ''));
                      self.idInfoEvolution = cluster_id;
                    } else {
                      self.idInfoEvolution = '';
                    }
                  } else {
                    self.idInfoEvolution = '';
                  }
                  var layerWithContent = Object.keys(features)
                    .filter(el => features[el].length > 0);
                  if ([...Object.values(features)].length > 0 && layerWithContent.length > 0) {
                    // Add the content to the popup
                    var layerOrdered = self.correspondances
                      .slice()
                      .reverse()
                      .map(el => {
                        return {
                          title: el.layer.title,
                          cols: el.layer.cols || [],
                          layer: el.layer.params.LAYERS,
                          template: el.layer.template || '',
                          identifier: el.id
                        }
                      })
                      .filter(el => layerWithContent.indexOf(el.layer) !== -1);
                      layerOrdered = removeDuplicates(layerOrdered, 'layer');

                      if (self.queryable_layers.indexOf('general:courseau_fxx') !== -1) {
                        layerOrdered = [{
                          "identifier": "courseau_fxx",
                          "title": "Cours d'eau",
                          "cols": [
                            "topooh"
                          ],
                          "layer": "general:courseau_fxx",
                          "template": "{{topooh}}"
                        },
                        ...layerOrdered
                        ];
                      }
                      var layerOrderedFixFeatures = layerOrdered
                      .map(el => {
                        features[el.layer] = features[el.layer]
                          .filter(feature => {
                            return feature.getId().split('.')[0] == el.layer.split(':')[1];
                          });
                        return el;
                      })
                      .filter(el => {
                        if (features[el.layer].length > 0) {
                          features[el.layer] = features[el.layer].slice(0, 1);
                          return features[el.layer].map(el1 => {
                            return Array.from(new Set(el.cols.map(el2 => {
                              return el1.get(el2);
                            })));
                          })
                          .filter(el => el[0] !== undefined).length > 0
                        } else {
                          return false;
                        }
                        // return features[el.layer].length > 0;
                      });

                      var myWmsFeatures = layerOrderedFixFeatures.reduce((acc, curr)=> {
                        var flatened = features[curr.layer].map(feat => {
                          feat.set('identifier', curr.identifier);
                          return feat;
                        });
                        acc = [...acc, ...flatened];
                        return acc;
                      }, []);

                      if (myFeatures.length == 0) {
                        this.highlight_layer.getSource().clear();
                      }
                      this.highlight_layer.getSource().addFeatures(myWmsFeatures);

                      var html = layerOrderedFixFeatures.map(el => {
                        return '<span style="font-weight: bold;">' +
                          el.title + '</span>' + '<br>' +
                          features[el.layer].filter(el1 => {
                            // filter to remove empty results
                            var tmp = Array.from(new Set(el.cols.map(el2 => {
                              return el1.get(el2);
                            })));
                            if (tmp[0] !== undefined) {
                              return true;
                            } else {
                              return false;
                            }
                          }).filter((el1, index) => {
                            // Take only first result
                            return index == 0;
                          })
                          .map(feat => {
                            let textPopupContent = el.cols.reduce((acc, col, index) => {
                              // debugger;
                              acc[col] = feat.get(col);
                              if (index === 0 && (el.layer.startsWith('general:points_') || el.layer.startsWith('general:pointsnext_')) && !el.layer.includes('evolution') && acc[col] !== undefined) {
                                acc[col] = acc[col] !== 0 ? Number(Number(acc[col]).toFixed(1)) : 0
                              }
                              if (index === 0 && (el.layer.startsWith('general:points_') || el.layer.startsWith('general:pointsnext_')) && el.layer.includes('evolution') && acc[col] !== undefined) {
                                if (col !== 'html') {
                                  acc[col] = acc[col] !== 0 ? (acc[col] > 0 ? '+' +String(Number(Number(acc[col]).toFixed(4))): Number(Number(acc[col]).toFixed(4))) : '';
                                }
                                if (el.cols.length == 1) {
                                  acc['espece'] = especes_by_key[col.replace('tx_evol_den_', '')];
                                }
                              }
                              if (index === 0 && el.layer.includes('taux_etagement_bsn') && acc[col] !== undefined) {
                                acc[col] = acc[col] < 0 || acc[col] > 1 ? 'Non renseigné' : Number(Number(acc[col]) * 100).toFixed(1) + '%';
                              }

                              // if (index === 0 && el.layer.includes('stations_echantillonnage_latest') && acc[col] !== undefined) {
                              //   if (col == 'station') {
                              //     acc['station1'] = acc[col].replace(/#/g, 'D');
                              //     // console.log(acc['station1']);
                              //   }
                              // }
                              // For Habitats aquatiques or ripisylve data columns
                              if (col === 'taux_vege1' || col === 'taux_recti' && acc[col] !== undefined) {
                                acc[col] = Number(acc[col]).toFixed(1);
                              }
                              if (col === 'note_ipr' && acc[col] !== undefined) {
                                acc[col] = Number(acc[col]).toFixed(2);
                              }
                              return acc;
                            }, {});
                            return micromustache.render(
                              el.template,
                              textPopupContent
                            );
                          })
                          .map(el => {
                            if (el.length == 0) {
                              return 'Absence de données';
                            } else {
                              return el;
                            }
                          })
                          .join('<br>');
                      });
                      self.popup_element = html.join('<br>');
                      if (self.popup_element.length > 0 || featureTravaux) {
                        self.right_panel = true;
                      } else {
                        if (featureTravaux) {
                          self.right_panel = true;
                        } else {
                          self.right_panel = false;
                        }
                      }
                  } else {
                    if (featureTravaux) {
                      self.right_panel = true;
                    } else {
                      self.right_panel = false;
                    }
                  }
                })
            } else {
              if (featureTravaux) {
                self.right_panel = true;
              } else {
                self.right_panel = false;
              }
            }
          }
        }
      });
    });

    var libellesTravaux = ["Restauration de la continuit\u00e9 \u00e9cologique", "Restauration de zones humides", "Restauration hydromorphologique"];
    var colorsTravaux = ['#fc8d62', '#8da0cb', '#66c2a5'];

    var libellesEchantillonnages = ['Institutions', 'Structures de p\u00eache de loisir', 'Collectivités'];
    var colorsEchantillonnages = ['#984ea3', '#d95f02', '#7a6c5d'];

    var margin = {top: 10, right: 20, bottom: 80, left: 20},
        width = 220 - margin.left - margin.right,
        height = 140 - margin.top - margin.bottom;

    var barChartEchantillonnage = new BarChart(
      '#barchart',
      height,
      width,
      margin,
      colorsEchantillonnages,
      libellesEchantillonnages
    );
    this.barChartEchantillonnage = barChartEchantillonnage;

    var barChartTravaux = new BarChart(
      '#barchart-travaux',
      height,
      width,
      margin,
      colorsTravaux,
      libellesTravaux
    );
    this.barChartTravaux = barChartTravaux;

    var barChartIPR = new BarChartIPR(
      '#barchart-ipr',
      240,
      width,
      {top: 10, right: 20, bottom: 80, left: 30}
    );
    this.barChartIPR = barChartIPR;

    var widthPie = 220,
    heightPie = 220,
    radiusPie = 80;

    var pieChartEchantillonnage = new PieChart(
      '#piechart',
      widthPie,
      heightPie,
      radiusPie,
      colorsEchantillonnages,
      libellesEchantillonnages
    );
    this.pieChartEchantillonnage = pieChartEchantillonnage;

    this.updateHtmlLegendPieChart(
      'echantillonnages-legend',
      libellesEchantillonnages,
      colorsEchantillonnages
    );

    var pieChartTravaux = new PieChart(
      '#piechart-travaux',
      widthPie,
      heightPie,
      radiusPie,
      colorsTravaux,
      libellesTravaux
    );
    this.pieChartTravaux = pieChartTravaux;

    this.updateHtmlLegendPieChart(
      'travaux-legend',
      libellesTravaux,
      colorsTravaux
    );

    this.barChartEvolutionSpecies = new BarChartEvolutionSpecies(
      '#barchart-evolution-species',
      140,
      width,
      {top: 10, right: 20, bottom: 40, left: 40}
    );

    var libellesEvolutionTendances = [
      'abl', 'asp', 'baf', 'bbg', 'bln', 'bou', 'brb', 'bre', 'bro', 'cad',
      'cag', 'car', 'cas', 'cco', 'ccu', 'cha', 'che', 'cmi', 'cti', 'epi',
      'ept', 'gar', 'gob', 'gou', 'gre', 'hot', 'ide', 'loe', 'lof', 'lor',
      'lot', 'lpp', 'obr', 'pch', 'per', 'pes', 'psr', 'rot', 'san', 'sdf',
      'sil', 'spi', 'tac', 'tan', 'trf', 'ump', 'vai', 'van', 'var', 'Autres'
    ];
    //var codeEvolutionTendances = ['Institutions', 'Structures de p\u00eache de loisir'];
    var colorsEvolutionTendances = [
      '#f9ebea', '#fdedec', '#f5eef8', '#f4ecf7', '#eaf2f8', '#ebf5fb', '#e8f8f5', '#e8f6f3', '#e9f7ef', '#eafaf1',
      '#e6b0aa', '#f5b7b1', '#d7bde2', '#d2b4de', '#a9cce3', '#aed6f1', '#a3e4d7', '#a2d9ce', '#a9dfbf', '#abebc6',
      '#cd6155', '#ec7063', '#af7ac5', '#a569bd', '#5499c7', '#5dade2', '#48c9b0', '#45b39d', '#52be80', '#58d68d',
      '#a93226', '#cb4335', '#884ea0', '#7d3c98', '#2471a3', '#2e86c1', '#17a589', '#138d75', '#229954', '#28b463',
      '#7b241c', '#943126', '#633974', '#5b2c6f', '#1a5276', '#21618c', '#117864', '#0e6655', '#196f3d', '#1d8348'
    ];
    var pieContextePiscicoleSalmonicole = new PieChart(
      '#piechart-contexte-piscicole-salmonicole',
      widthPie,
      heightPie,
      radiusPie,
      colorsEvolutionTendances,
      libellesEvolutionTendances
    );
    this.pieContextePiscicoleSalmonicole = pieContextePiscicoleSalmonicole;

    var pieContextePiscicoleIntermediaire = new PieChart(
      '#piechart-contexte-piscicole-intermediaire',
      widthPie,
      heightPie,
      radiusPie,
      colorsEvolutionTendances,
      libellesEvolutionTendances
    );
    this.pieContextePiscicoleIntermediaire = pieContextePiscicoleIntermediaire;

    var pieContextePiscicoleCyprinicole = new PieChart(
      '#piechart-contexte-piscicole-cyprinicole',
      widthPie,
      heightPie,
      radiusPie,
      colorsEvolutionTendances,
      libellesEvolutionTendances
    );
    this.pieContextePiscicoleCyprinicole = pieContextePiscicoleCyprinicole;

    var slider = this.slider = createD3RangeSlider(this.minDate, this.maxDate, "#slider-container");

    // slider.range(this.minSelectedDate, this.maxSelectedDate);
    slider.onChange(function(newRange) {
        self.minSelectedDate = newRange.begin;
        self.maxSelectedDate = newRange.end;
        d3.select("#range-label").text(newRange.begin + " - " + newRange.end);
    });

    // To get the right width for the slider,
    // we need to watch show_restauration_ecologique
    // and stop watching after it runs once
    // Borrowed from https://medium.com/@bmacher/vue-watch-only-once-63597466dc74
    this.unwatch_show_restauration_ecologique = this.$watch('show_restauration_ecologique', (newVal) => {
      if (newVal) {
        slider.range(this.minSelectedDate, this.maxSelectedDate);
        this.unwatch_show_restauration_ecologique();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/home.js